const translations = {
    es: {
        app: { subtitle: 'Mensajería sin barreras de idioma' },
        login: {
            signin: 'Iniciar sesión', signup: 'Registrarse',
            phone: 'Teléfono', phonePlaceholder: '+34634123456',
            phoneFormatHint: 'Escribe el teléfono con código país. Ejemplo: +34634123456',
            password: 'Contraseña', passwordPlaceholder: '••••••••',
            passwordMin: 'Mínimo 6 caracteres',
            repeatPassword: 'Repetir contraseña', repeatPasswordPlaceholder: 'Repite la contraseña',
            name: 'Nombre', namePlaceholder: 'Tu nombre',
            language: 'Idioma', languagePlaceholder: 'ej: español, euskera...',
            region: 'Región', regionPlaceholder: 'País o ciudad',
            entering: 'Entrando...', enter: 'Entrar',
            creating: 'Registrando...', createAccount: 'Crear cuenta',
            error: {
                fillRequired: 'Completa todos los campos obligatorios',
                passwordMismatch: 'Las contraseñas no coinciden',
                passwordLength: 'La contraseña debe tener al menos 6 caracteres',
                phonePassword: 'Teléfono o contraseña incorrectos',
                registerFailed: 'Error al registrarse',
                connection: 'Error al conectar con el servidor',
                phoneRequired: 'Introduce tu teléfono y contraseña'
            }
        },
        conv: {
            loading: 'Cargando...', createGroup: 'Crear grupo', logout: 'Cerrar sesión',
            noLongerMember: 'Ya no eres miembro', noMessages: 'Sin mensajes',
            contacts: 'Contactos', noUsers: 'No hay usuarios disponibles',
            noConversationsYet: 'Aún no tienes chats. Abre la pestaña Contactos para empezar uno.',
            notInContacts: 'No está en tus contactos',
            addToContacts: 'Añadir'
        },
        chat: {
            loading: 'Cargando mensajes...', selectConversation: 'Selecciona una conversación para empezar a chatear',
            searchPlaceholder: 'Buscar en la conversación...', members: 'miembros',
            online: 'En línea', typingPlaceholder: 'Escribe en', send: 'Enviar',
            sendImage: 'Enviar Imagen', sendVideo: 'Enviar Video', sendAudio: 'Enviar Audio',
            sendDocument: 'Enviar Documento', processing: 'Procesando video...',
            translating: 'Traduciendo y enviando...', sending: 'Enviando...',
            transcribing: 'Transcribiendo subtítulos...',
            recording: 'Grabando...', deleted: 'Este mensaje fue eliminado',
            addCaption: 'Añade un mensaje (opcional)...',
            clearChatConfirm: '¿Vaciar el chat? Los mensajes solo se eliminarán para ti.',
            deleteConvConfirm: '¿Eliminar esta conversación? No podrás recuperarla.',
            leaveGroupConfirm: '¿Salir del grupo?', leaveGroupWarning: 'Ya no podrás ver los mensajes ni participar en este grupo.',
            leaveGroupAdmin: '⚠️ Eres el único admin. Debes transferir la administración antes de salir.',
            leave: 'Salir del grupo', cancel: 'Cancelar',
            forward: 'Reenviar', forwardMsg: 'Reenviar mensaje',
            deleteMsg: 'Eliminar mensaje', deleteForMe: 'Eliminar para mí', deleteForAll: 'Eliminar para todos',
            formerMember: 'Ya no eres miembro de este grupo',
            conversations: 'Conversaciones', groups: 'Grupos', loading2: 'Cargando...',
            searchMenu: '🔍 Buscar', addMember: '➕ Añadir miembro', groupInfo: 'ℹ️ Info del grupo',
            contactInfo: 'ℹ️ Info del contacto', muteNotif: '🔕 Silenciar notificaciones',
            unmuteNotif: '🔔 Activar notificaciones', addFav: '⭐ Añadir a favoritos',
            removeFav: '★ Quitar de favoritos', block: '🚫 Bloquear', unblock: '✅ Desbloquear',
            clearChat: '🗑️ Vaciar chat', deleteChat: '❌ Eliminar chat', leaveGroupMenu: '🚪 Salir del grupo',
            pause: '⏸ Pausar', stop: '⏹ Detener', continue: '▶ Continuar',
            attach: '📎 Adjuntar', gallery: '🖼️ Galería', document: '📄 Documento',
            camera: '📷 Cámara', recordVideo: '🎥 Grabar video', audio: '🎙️ Audio',
            voiceTranslation: 'Traducción de voz en tiempo real', listening: '🌐 Escuchando...',
            stopRecording: '⏹ Detener', errorSendMessage: 'Error al enviar mensaje',
            errorSendVideo: 'Error al enviar video', errorSendDocument: 'Error al enviar documento',
            errorCamera: 'No se pudo acceder a la cámara', errorMic: 'No se pudo acceder al micrófono.',
            errorVoice: 'Tu navegador no soporta reconocimiento de voz',
            capture: '📷 Capturar', record: '🔴 Grabar', stopBtn: '⏹ Detener', cancelBtn: '✕ Cancelar',
            contactCard: {
                type: 'Contacto KAIXO',
                add: 'Añadir a contactos',
                close: 'Cerrar',
                labelPhone: 'Teléfono',
                labelEmail: 'Email',
                labelLanguage: 'Idioma',
                labelPlace: 'Lugar',
                noName: '(sin nombre)',
                fallbackName: 'Contacto KAIXO',
                errNoPhone: 'Sin teléfono — no se puede guardar',
                errMobileOnly: 'Esta acción solo funciona en la app móvil',
                errPermDenied: 'Permiso de contactos denegado',
                savedSuffix: 'guardado en tu agenda',
                errSavePrefix: 'No se pudo guardar',
                viewProfile: 'Ver perfil'
            },
                correct: {"button": "Corregir", "title": "Corregir ortografia y gramatica", "changed": "Corregido", "clean": "Sin errores", "error": "No se pudo corregir"},
                photoTranslate: {"hint": "Apunta a un cartel o menu y dispara", "processing": "Leyendo y traduciendo...", "original": "Texto detectado", "translation": "En tu idioma", "listen": "Escuchar", "stop": "Detener", "copy": "Copiar", "sendToChat": "Enviar al chat", "another": "Otra foto", "retry": "Reintentar", "close": "Cerrar", "errCamera": "No se pudo acceder a la camara", "errProcess": "Error al procesar la foto", "noText": "No se detecto texto en la imagen", "attachLabel": "Fototraductor"}
        },
        profile: {
            title: 'Editar perfil', changePhoto: '📷 Cambiar foto',
            name: 'Nombre', namePlaceholder: 'Tu nombre',
            status: 'Estado', statusPlaceholder: 'Hey, estoy usando Kaixo!',
            language: 'Idioma', languagePlaceholder: 'ej: español, euskera...',
            region: 'Región', regionPlaceholder: 'País o ciudad',
            voice: 'Voz para mensajes', female: '👩 Femenina', male: '👨 Masculina',
            save: 'Guardar cambios', saving: 'Guardando...',
            error: { nameEmpty: 'El nombre no puede estar vacío', save: 'Error al guardar', connection: 'Error al conectar con el servidor' }
        },
        group: {
            participants: 'Participantes', add: '➕ Añadir', leave: '🚪 Salir del Grupo',
            delete: '🗑️ Eliminar Grupo', loading: 'Cargando contactos...',
            noContacts: 'Todos tus contactos ya están en este grupo',
            selected: 'seleccionados', addBtn: 'Añadir',
            leaveConfirm: '¿Salir del grupo?', leaveWarning: 'Ya no podrás ver los mensajes ni participar en este grupo.',
            deleteConfirm: 'Esta acción NO se puede deshacer. El grupo será eliminado para TODOS los miembros.',
            deleteConfirmText: '¿Estás seguro que deseas continuar?',
            transferAdmin: 'Transferir Administración', transferDesc: 'Debes nombrar a otro administrador antes de salir del grupo.',
            transferAndLeave: 'Transferir y Salir', creator: '👑 Creador', admin: '⭐ Admin',
            cancel: 'Cancelar', danger: 'Salir del Grupo', yesDelete: 'Sí, Eliminar Grupo',
            error: { noContacts: 'Selecciona al menos un contacto', add: 'Error al añadir miembros', remove: 'Error al eliminar miembro', leave: 'Error al salir del grupo', delete: 'Error al eliminar grupo', removeCreator: 'No puedes eliminar al creador del grupo' }
        },
        createGroup: {
            title: 'Crear Nuevo Grupo', groupName: 'Nombre del grupo',
            groupNamePlaceholder: 'Ej: Amigos, Familia, Trabajo...',
            selectMembers: 'Seleccionar miembros', noUsers: 'No hay usuarios disponibles',
            cancel: 'Cancelar', creating: 'Creando...', create: 'Crear Grupo',
            error: { noName: 'Por favor ingresa un nombre para el grupo', noMembers: 'Selecciona al menos un contacto', create: 'Error al crear grupo' }
        },
        doc: {
            noPreview: 'Este tipo de archivo no tiene vista previa de texto.',
            downloadMsg: 'Puedes descargarlo para verlo.',
            sendTo: 'Enviar a...', send: 'Enviar', cancel: 'Cancelar'
        },
        interestPicker: {
            title: 'Selecciona tus intereses',
            subtitle: 'Marca todos los que quieras y pulsa Aceptar',
            accept: 'Aceptar',
            cancel: 'Cancelar',
            limitReached: 'Límite alcanzado',
            openButton: 'Seleccionar intereses'
        },
        contacts: {
            title: 'Contactos',
            search: 'Buscar...',
            withKaixo: 'En KAIXO',
            invite: 'Invitar',
            inviteAll: 'Invitar a todos',
            emptyTitle: 'Aún no se ven contactos',
            emptyDesc: 'Permite a KAIXO leer tu agenda para encontrar a quién ya está dentro.',
            permissionBtn: 'Permitir acceso a contactos',
            permissionDeniedTitle: 'Permiso denegado',
            permissionDeniedDesc: 'Abre Ajustes → KAIXO → Permisos → Contactos para activarlo.',
            webOnlyTitle: 'Disponible en la app móvil',
            webOnlyDesc: 'Para ver tus contactos del teléfono instala KAIXO en Android o iOS.',
            retry: 'Reintentar',
            loading: 'Cargando contactos...',
            syncing: 'Sincronizando...',
            noResults: 'Sin resultados',
            noKaixoYet: 'Ninguno de tus contactos tiene KAIXO todavía. Invítales abajo.',
            kaixoBadge: 'KAIXO',
            otherContacts: 'Otros contactos del teléfono',
            inviteText: '¡Te invito a KAIXO! Habla con cualquier persona del mundo y cada uno lee en su idioma. Descárgala: ',
            newBadge: 'NUEVO',
            unknownSenders: 'Mensajes de personas no en tu agenda'
        },
        direct: {
            tagline: 'Habla con cualquiera. Cualquier idioma. Sin que descarguen nada.',
            yourLang: 'Tu idioma',
            otherLang: 'Idioma de la otra persona',
            swap: 'Intercambiar idiomas',
            start: 'Empezar',
            legal: 'El audio se envía a nuestros servicios de IA para traducirlo. Se borra tras la respuesta. No usamos tus conversaciones para entrenar modelos.',
            errMic: 'No se pudo acceder al micrófono: ',
            errTooShort: 'Audio demasiado corto, mantén pulsado mientras hablas',
            holdToTalk: 'Mantén pulsado para hablar',
            sending: 'Enviando...',
            playing: 'Reproduciendo...'
        }
    },
    en: {
        app: { subtitle: 'Messaging without language barriers' },
        login: {
            signin: 'Sign in', signup: 'Sign up',
            phone: 'Phone', phonePlaceholder: '+16001234567',
            phoneFormatHint: 'Type your phone with country code. Example: +16001234567',
            password: 'Password', passwordPlaceholder: '••••••••',
            passwordMin: 'At least 6 characters',
            repeatPassword: 'Repeat password', repeatPasswordPlaceholder: 'Repeat your password',
            name: 'Name', namePlaceholder: 'Your name',
            language: 'Language', languagePlaceholder: 'e.g.: english, spanish...',
            region: 'Region', regionPlaceholder: 'Country or city',
            entering: 'Signing in...', enter: 'Sign in',
            creating: 'Registering...', createAccount: 'Create account',
            error: {
                fillRequired: 'Please fill in all required fields',
                passwordMismatch: 'Passwords do not match',
                passwordLength: 'Password must be at least 6 characters',
                phonePassword: 'Incorrect phone or password',
                registerFailed: 'Registration failed',
                connection: 'Error connecting to server',
                phoneRequired: 'Enter your phone and password'
            }
        },
        conv: {
            loading: 'Loading...', createGroup: 'Create group', logout: 'Log out',
            noLongerMember: 'No longer a member', noMessages: 'No messages',
            contacts: 'Contacts', noUsers: 'No users available',
            noConversationsYet: 'No chats yet. Open the Contacts tab to start one.',
            notInContacts: 'Not in your contacts',
            addToContacts: 'Add'
        },
        chat: {
            loading: 'Loading messages...', selectConversation: 'Select a conversation to start chatting',
            searchPlaceholder: 'Search in conversation...', members: 'members',
            online: 'Online', typingPlaceholder: 'Type in', send: 'Send',
            sendImage: 'Send Image', sendVideo: 'Send Video', sendAudio: 'Send Audio',
            sendDocument: 'Send Document', processing: 'Processing video...',
            translating: 'Translating and sending...', sending: 'Sending...',
            transcribing: 'Transcribing subtitles...',
            recording: 'Recording...', deleted: 'This message was deleted',
            addCaption: 'Add a message (optional)...',
            clearChatConfirm: 'Clear chat? Messages will only be deleted for you.',
            deleteConvConfirm: 'Delete this conversation? You cannot recover it.',
            leaveGroupConfirm: 'Leave group?', leaveGroupWarning: 'You will no longer be able to see messages or participate in this group.',
            leaveGroupAdmin: '⚠️ You are the only admin. Transfer admin before leaving.',
            leave: 'Leave group', cancel: 'Cancel',
            forward: 'Forward', forwardMsg: 'Forward message',
            deleteMsg: 'Delete message', deleteForMe: 'Delete for me', deleteForAll: 'Delete for everyone',
            formerMember: 'You are no longer a member of this group',
            conversations: 'Conversations', groups: 'Groups', loading2: 'Loading...',
            searchMenu: '🔍 Search', addMember: '➕ Add member', groupInfo: 'ℹ️ Group info',
            contactInfo: 'ℹ️ Contact info', muteNotif: '🔕 Mute notifications',
            unmuteNotif: '🔔 Unmute notifications', addFav: '⭐ Add to favorites',
            removeFav: '★ Remove from favorites', block: '🚫 Block', unblock: '✅ Unblock',
            clearChat: '🗑️ Clear chat', deleteChat: '❌ Delete chat', leaveGroupMenu: '🚪 Leave group',
            pause: '⏸ Pause', stop: '⏹ Stop', continue: '▶ Continue',
            attach: '📎 Attach', gallery: '🖼️ Gallery', document: '📄 Document',
            camera: '📷 Camera', recordVideo: '🎥 Record video', audio: '🎙️ Audio',
            voiceTranslation: 'Real-time voice translation', listening: '🌐 Listening...',
            stopRecording: '⏹ Stop', errorSendMessage: 'Error sending message',
            errorSendVideo: 'Error sending video', errorSendDocument: 'Error sending document',
            errorCamera: 'Could not access camera', errorMic: 'Could not access microphone.',
            errorVoice: 'Your browser does not support voice recognition',
            capture: '📷 Capture', record: '🔴 Record', stopBtn: '⏹ Stop', cancelBtn: '✕ Cancel',
            contactCard: {
                type: 'KAIXO contact',
                add: 'Add to contacts',
                close: 'Close',
                labelPhone: 'Phone',
                labelEmail: 'Email',
                labelLanguage: 'Language',
                labelPlace: 'Location',
                noName: '(no name)',
                fallbackName: 'KAIXO Contact',
                errNoPhone: 'No phone — cannot save',
                errMobileOnly: 'This action only works in the mobile app',
                errPermDenied: 'Contacts permission denied',
                savedSuffix: 'saved to your address book',
                errSavePrefix: 'Could not save',
                viewProfile: 'View profile'
            },
                correct: {"button": "Correct", "title": "Fix spelling and grammar", "changed": "Corrected", "clean": "No errors", "error": "Could not correct"},
                photoTranslate: {"hint": "Point at a sign or menu and shoot", "processing": "Reading and translating...", "original": "Detected text", "translation": "In your language", "listen": "Listen", "stop": "Stop", "copy": "Copy", "sendToChat": "Send to chat", "another": "Another photo", "retry": "Retry", "close": "Close", "errCamera": "Could not access camera", "errProcess": "Could not process the photo", "noText": "No text detected in the image", "attachLabel": "Photo Translator"}
        },
        profile: {
            title: 'Edit profile', changePhoto: '📷 Change photo',
            name: 'Name', namePlaceholder: 'Your name',
            status: 'Status', statusPlaceholder: 'Hey, I am using Kaixo!',
            language: 'Language', languagePlaceholder: 'e.g.: english, spanish...',
            region: 'Region', regionPlaceholder: 'Country or city',
            voice: 'Message voice', female: '👩 Female', male: '👨 Male',
            save: 'Save changes', saving: 'Saving...',
            error: { nameEmpty: 'Name cannot be empty', save: 'Error saving', connection: 'Error connecting to server' }
        },
        group: {
            participants: 'Participants', add: '➕ Add', leave: '🚪 Leave Group',
            delete: '🗑️ Delete Group', loading: 'Loading contacts...',
            noContacts: 'All your contacts are already in this group',
            selected: 'selected', addBtn: 'Add',
            leaveConfirm: 'Leave group?', leaveWarning: 'You will no longer see messages or participate in this group.',
            deleteConfirm: 'This action CANNOT be undone. The group will be deleted for ALL members.',
            deleteConfirmText: 'Are you sure you want to continue?',
            transferAdmin: 'Transfer Administration', transferDesc: 'You must assign another admin before leaving.',
            transferAndLeave: 'Transfer and Leave', creator: '👑 Creator', admin: '⭐ Admin',
            cancel: 'Cancel', danger: 'Leave Group', yesDelete: 'Yes, Delete Group',
            error: { noContacts: 'Select at least one contact', add: 'Error adding members', remove: 'Error removing member', leave: 'Error leaving group', delete: 'Error deleting group', removeCreator: 'You cannot remove the group creator' }
        },
        createGroup: {
            title: 'Create New Group', groupName: 'Group name',
            groupNamePlaceholder: 'e.g.: Friends, Family, Work...',
            selectMembers: 'Select members', noUsers: 'No users available',
            cancel: 'Cancel', creating: 'Creating...', create: 'Create Group',
            error: { noName: 'Please enter a group name', noMembers: 'Select at least one contact', create: 'Error creating group' }
        },
        doc: {
            noPreview: 'This file type has no text preview.',
            downloadMsg: 'You can download it to view it.',
            sendTo: 'Send to...', send: 'Send', cancel: 'Cancel'
        },
        interestPicker: {
            title: 'Select your interests',
            subtitle: 'Pick as many as you want and tap Accept',
            accept: 'Accept',
            cancel: 'Cancel',
            limitReached: 'Limit reached',
            openButton: 'Select interests'
        },
        contacts: {
            title: 'Contacts',
            search: 'Search...',
            withKaixo: 'On KAIXO',
            invite: 'Invite',
            inviteAll: 'Invite all',
            emptyTitle: 'No contacts visible yet',
            emptyDesc: 'Let KAIXO read your phone book to find who is already in.',
            permissionBtn: 'Allow contacts access',
            permissionDeniedTitle: 'Permission denied',
            permissionDeniedDesc: 'Open Settings → KAIXO → Permissions → Contacts to enable it.',
            webOnlyTitle: 'Available on the mobile app',
            webOnlyDesc: 'To see your phone contacts install KAIXO on Android or iOS.',
            retry: 'Retry',
            loading: 'Loading contacts...',
            syncing: 'Syncing...',
            noResults: 'No results',
            noKaixoYet: 'None of your contacts has KAIXO yet. Invite them below.',
            kaixoBadge: 'KAIXO',
            otherContacts: 'Other phone contacts',
            inviteText: 'I invite you to KAIXO! Talk to anyone in the world and each person reads in their own language. Get it: ',
            newBadge: 'NEW',
            unknownSenders: 'Messages from people not in your contacts'
        },
        direct: {
            tagline: 'Talk to anyone. Any language. They do not need to install anything.',
            yourLang: 'Your language',
            otherLang: 'Other person\u2019s language',
            swap: 'Swap languages',
            start: 'Start',
            legal: 'Audio is sent to our AI services to translate it. It is deleted after the response. We do not use your conversations to train models.',
            errMic: 'Could not access the microphone: ',
            errTooShort: 'Audio too short, hold the button while you speak',
            holdToTalk: 'Hold to talk',
            sending: 'Sending...',
            playing: 'Playing...'
        }
    },
    fr: {
        app: { subtitle: 'Messagerie sans barrières linguistiques' },
        login: {
            signin: 'Se connecter', signup: "S'inscrire",
            phone: 'Téléphone', phonePlaceholder: '+33 6 00 00 00 00',
            password: 'Mot de passe', passwordPlaceholder: '••••••••',
            passwordMin: 'Au moins 6 caractères',
            repeatPassword: 'Répéter le mot de passe', repeatPasswordPlaceholder: 'Répétez votre mot de passe',
            name: 'Nom', namePlaceholder: 'Votre nom',
            language: 'Langue', languagePlaceholder: 'ex: français, anglais...',
            region: 'Région', regionPlaceholder: 'Pays ou ville',
            entering: 'Connexion...', enter: 'Entrer',
            creating: 'Inscription...', createAccount: 'Créer un compte',
            error: {
                fillRequired: 'Remplissez tous les champs obligatoires',
                passwordMismatch: 'Les mots de passe ne correspondent pas',
                passwordLength: 'Le mot de passe doit contenir au moins 6 caractères',
                phonePassword: 'Téléphone ou mot de passe incorrect',
                registerFailed: "Échec de l'inscription",
                connection: 'Erreur de connexion au serveur',
                phoneRequired: 'Entrez votre téléphone et mot de passe'
            }
        },
        conv: {
            loading: 'Chargement...', createGroup: 'Créer un groupe', logout: 'Déconnexion',
            noLongerMember: "N'êtes plus membre", noMessages: 'Aucun message',
            contacts: 'Contacts', noUsers: 'Aucun utilisateur disponible'
        },
        chat: {
            loading: 'Chargement des messages...', selectConversation: 'Sélectionnez une conversation pour commencer',
            searchPlaceholder: 'Rechercher dans la conversation...', members: 'membres',
            online: 'En ligne', typingPlaceholder: 'Écrivez en', send: 'Envoyer',
            sendImage: 'Envoyer image', sendVideo: 'Envoyer vidéo', sendAudio: 'Envoyer audio',
            sendDocument: 'Envoyer document', processing: 'Traitement vidéo...',
            translating: 'Traduction et envoi...', sending: 'Envoi...',
            recording: 'Enregistrement...', deleted: 'Ce message a été supprimé',
            addCaption: 'Ajouter un message (optionnel)...',
            clearChatConfirm: 'Vider le chat? Les messages ne seront supprimés que pour vous.',
            deleteConvConfirm: 'Supprimer cette conversation? Vous ne pourrez pas la récupérer.',
            leaveGroupConfirm: 'Quitter le groupe?', leaveGroupWarning: 'Vous ne pourrez plus voir les messages ni participer.',
            leaveGroupAdmin: '⚠️ Vous êtes le seul admin. Transférez avant de quitter.',
            leave: 'Quitter le groupe', cancel: 'Annuler',
            forward: 'Transférer', forwardMsg: 'Transférer le message',
            deleteMsg: 'Supprimer le message', deleteForMe: 'Supprimer pour moi', deleteForAll: 'Supprimer pour tous',
            formerMember: "Vous n'êtes plus membre de ce groupe",
            conversations: 'Conversations', groups: 'Groupes', loading2: 'Chargement...',
            searchMenu: '🔍 Rechercher', addMember: '➕ Ajouter membre', groupInfo: 'ℹ️ Info groupe',
            contactInfo: 'ℹ️ Info contact', muteNotif: '🔕 Désactiver notifications',
            unmuteNotif: '🔔 Activer notifications', addFav: '⭐ Ajouter aux favoris',
            removeFav: '★ Retirer des favoris', block: '🚫 Bloquer', unblock: '✅ Débloquer',
            clearChat: '🗑️ Vider le chat', deleteChat: '❌ Supprimer conversation', leaveGroupMenu: '🚪 Quitter le groupe',
            pause: '⏸ Pause', stop: '⏹ Arrêter', continue: '▶ Continuer',
            attach: '📎 Joindre', gallery: '🖼️ Galerie', document: '📄 Document',
            camera: '📷 Caméra', recordVideo: '🎥 Enregistrer vidéo', audio: '🎙️ Audio',
            voiceTranslation: 'Traduction vocale en temps réel', listening: '🌐 Écoute...',
            stopRecording: '⏹ Arrêter', errorSendMessage: "Erreur d'envoi du message",
            errorSendVideo: "Erreur d'envoi de la vidéo", errorSendDocument: "Erreur d'envoi du document",
            errorCamera: "Impossible d'accéder à la caméra", errorMic: "Impossible d'accéder au microphone.",
            errorVoice: 'Votre navigateur ne supporte pas la reconnaissance vocale',
            capture: '📷 Capturer', record: '🔴 Enregistrer', stopBtn: '⏹ Arrêter', cancelBtn: '✕ Annuler',
            contactCard: {
                type: 'Contact KAIXO',
                add: 'Ajouter aux contacts',
                close: 'Fermer',
                labelPhone: 'Téléphone',
                labelEmail: 'E-mail',
                labelLanguage: 'Langue',
                labelPlace: 'Lieu',
                noName: '(sans nom)',
                fallbackName: 'Contact KAIXO',
                errNoPhone: 'Pas de téléphone — impossible d’enregistrer',
                errMobileOnly: 'Cette action ne fonctionne que dans l’app mobile',
                errPermDenied: 'Permission contacts refusée',
                savedSuffix: 'enregistré dans votre carnet',
                errSavePrefix: 'Échec de l’enregistrement',
                viewProfile: 'Voir le profil'
            },
                correct: {"button": "Corriger", "title": "Corriger orthographe et grammaire", "changed": "Corrige", "clean": "Sans erreurs", "error": "Echec de la correction"},
                photoTranslate: {"hint": "Vise un panneau ou un menu et declenche", "processing": "Lecture et traduction...", "original": "Texte detecte", "translation": "Dans ta langue", "listen": "Ecouter", "stop": "Arrêter", "copy": "Copier", "sendToChat": "Envoyer au chat", "another": "Autre photo", "retry": "Reessayer", "close": "Fermer", "errCamera": "Impossible d acceder a la camera", "errProcess": "Echec du traitement", "noText": "Aucun texte detecte", "attachLabel": "Photo-traducteur"}
        },
        profile: {
            title: 'Modifier le profil', changePhoto: '📷 Changer la photo',
            name: 'Nom', namePlaceholder: 'Votre nom',
            status: 'Statut', statusPlaceholder: "Hey, j'utilise Kaixo!",
            language: 'Langue', languagePlaceholder: 'ex: français, anglais...',
            region: 'Région', regionPlaceholder: 'Pays ou ville',
            voice: 'Voix pour les messages', female: '👩 Féminine', male: '👨 Masculine',
            save: 'Enregistrer', saving: 'Enregistrement...',
            error: { nameEmpty: 'Le nom ne peut pas être vide', save: "Erreur lors de l'enregistrement", connection: 'Erreur de connexion au serveur' }
        },
        group: {
            participants: 'Participants', add: '➕ Ajouter', leave: '🚪 Quitter le Groupe',
            delete: '🗑️ Supprimer le Groupe', loading: 'Chargement des contacts...',
            noContacts: 'Tous vos contacts sont déjà dans ce groupe',
            selected: 'sélectionnés', addBtn: 'Ajouter',
            leaveConfirm: 'Quitter le groupe?', leaveWarning: 'Vous ne pourrez plus voir les messages ni participer.',
            deleteConfirm: 'Cette action est IRRÉVERSIBLE. Le groupe sera supprimé pour TOUS les membres.',
            deleteConfirmText: 'Êtes-vous sûr de vouloir continuer?',
            transferAdmin: "Transférer l'Administration", transferDesc: 'Vous devez nommer un autre admin avant de partir.',
            transferAndLeave: 'Transférer et Quitter', creator: '👑 Créateur', admin: '⭐ Admin',
            cancel: 'Annuler', danger: 'Quitter le Groupe', yesDelete: 'Oui, Supprimer le Groupe',
            error: { noContacts: 'Sélectionnez au moins un contact', add: "Erreur d'ajout de membres", remove: 'Erreur de suppression', leave: 'Erreur pour quitter', delete: 'Erreur de suppression', removeCreator: 'Impossible de supprimer le créateur' }
        },
        createGroup: {
            title: 'Créer un Nouveau Groupe', groupName: 'Nom du groupe',
            groupNamePlaceholder: 'Ex: Amis, Famille, Travail...',
            selectMembers: 'Sélectionner des membres', noUsers: 'Aucun utilisateur disponible',
            cancel: 'Annuler', creating: 'Création...', create: 'Créer le Groupe',
            error: { noName: 'Veuillez entrer un nom de groupe', noMembers: 'Sélectionnez au moins un contact', create: 'Erreur de création du groupe' }
        },
        doc: {
            noPreview: "Ce type de fichier n'a pas d'aperçu texte.",
            downloadMsg: 'Vous pouvez le télécharger pour le voir.',
            sendTo: 'Envoyer à...', send: 'Envoyer', cancel: 'Annuler'
        }
    },
    de: {
        app: { subtitle: 'Messaging ohne Sprachbarrieren' },
        login: {
            signin: 'Anmelden', signup: 'Registrieren',
            phone: 'Telefon', phonePlaceholder: '+49 600 000 0000',
            password: 'Passwort', passwordPlaceholder: '••••••••',
            passwordMin: 'Mindestens 6 Zeichen',
            repeatPassword: 'Passwort wiederholen', repeatPasswordPlaceholder: 'Passwort wiederholen',
            name: 'Name', namePlaceholder: 'Ihr Name',
            language: 'Sprache', languagePlaceholder: 'z.B.: Deutsch, Englisch...',
            region: 'Region', regionPlaceholder: 'Land oder Stadt',
            entering: 'Anmeldung...', enter: 'Anmelden',
            creating: 'Registrierung...', createAccount: 'Konto erstellen',
            error: {
                fillRequired: 'Bitte alle Pflichtfelder ausfüllen',
                passwordMismatch: 'Passwörter stimmen nicht überein',
                passwordLength: 'Passwort muss mindestens 6 Zeichen haben',
                phonePassword: 'Falsche Telefonnummer oder Passwort',
                registerFailed: 'Registrierung fehlgeschlagen',
                connection: 'Fehler beim Verbinden mit dem Server',
                phoneRequired: 'Telefon und Passwort eingeben'
            }
        },
        conv: {
            loading: 'Laden...', createGroup: 'Gruppe erstellen', logout: 'Abmelden',
            noLongerMember: 'Kein Mitglied mehr', noMessages: 'Keine Nachrichten',
            contacts: 'Kontakte', noUsers: 'Keine Benutzer verfügbar'
        },
        chat: {
            loading: 'Nachrichten laden...', selectConversation: 'Wähle ein Gespräch zum Chatten',
            searchPlaceholder: 'Im Gespräch suchen...', members: 'Mitglieder',
            online: 'Online', typingPlaceholder: 'Schreiben auf', send: 'Senden',
            sendImage: 'Bild senden', sendVideo: 'Video senden', sendAudio: 'Audio senden',
            sendDocument: 'Dokument senden', processing: 'Video wird verarbeitet...',
            translating: 'Übersetzen und senden...', sending: 'Senden...',
            recording: 'Aufnahme...', deleted: 'Diese Nachricht wurde gelöscht',
            addCaption: 'Nachricht hinzufügen (optional)...',
            clearChatConfirm: 'Chat leeren? Nachrichten werden nur für dich gelöscht.',
            deleteConvConfirm: 'Gespräch löschen? Es kann nicht wiederhergestellt werden.',
            leaveGroupConfirm: 'Gruppe verlassen?', leaveGroupWarning: 'Du kannst keine Nachrichten mehr sehen.',
            leaveGroupAdmin: '⚠️ Du bist der einzige Admin. Übertrage vor dem Verlassen.',
            leave: 'Gruppe verlassen', cancel: 'Abbrechen',
            forward: 'Weiterleiten', forwardMsg: 'Nachricht weiterleiten',
            deleteMsg: 'Nachricht löschen', deleteForMe: 'Für mich löschen', deleteForAll: 'Für alle löschen',
            formerMember: 'Du bist kein Mitglied mehr dieser Gruppe',
            conversations: 'Gespräche', groups: 'Gruppen', loading2: 'Laden...',
            searchMenu: '🔍 Suchen', addMember: '➕ Mitglied hinzufügen', groupInfo: 'ℹ️ Gruppeninfo',
            contactInfo: 'ℹ️ Kontaktinfo', muteNotif: '🔕 Benachrichtigungen deaktivieren',
            unmuteNotif: '🔔 Benachrichtigungen aktivieren', addFav: '⭐ Zu Favoriten hinzufügen',
            removeFav: '★ Aus Favoriten entfernen', block: '🚫 Blockieren', unblock: '✅ Entsperren',
            clearChat: '🗑️ Chat leeren', deleteChat: '❌ Gespräch löschen', leaveGroupMenu: '🚪 Gruppe verlassen',
            pause: '⏸ Pause', stop: '⏹ Stopp', continue: '▶ Weiter',
            attach: '📎 Anhängen', gallery: '🖼️ Galerie', document: '📄 Dokument',
            camera: '📷 Kamera', recordVideo: '🎥 Video aufnehmen', audio: '🎙️ Audio',
            voiceTranslation: 'Echtzeit-Sprachübersetzung', listening: '🌐 Hört zu...',
            stopRecording: '⏹ Stopp', errorSendMessage: 'Fehler beim Senden der Nachricht',
            errorSendVideo: 'Fehler beim Senden des Videos', errorSendDocument: 'Fehler beim Senden des Dokuments',
            errorCamera: 'Kein Zugriff auf die Kamera', errorMic: 'Kein Zugriff auf das Mikrofon.',
            errorVoice: 'Dein Browser unterstützt keine Spracherkennung',
            capture: '📷 Aufnehmen', record: '🔴 Aufnehmen', stopBtn: '⏹ Stopp', cancelBtn: '✕ Abbrechen',
            contactCard: {
                type: 'KAIXO-Kontakt',
                add: 'Zu Kontakten hinzufügen',
                close: 'Schließen',
                labelPhone: 'Telefon',
                labelEmail: 'E-Mail',
                labelLanguage: 'Sprache',
                labelPlace: 'Ort',
                noName: '(ohne Namen)',
                fallbackName: 'KAIXO-Kontakt',
                errNoPhone: 'Keine Telefonnummer — kann nicht gespeichert werden',
                errMobileOnly: 'Diese Aktion funktioniert nur in der mobilen App',
                errPermDenied: 'Kontaktberechtigung verweigert',
                savedSuffix: 'in deinen Kontakten gespeichert',
                errSavePrefix: 'Konnte nicht gespeichert werden',
                viewProfile: 'Profil ansehen'
            },
                correct: {"button": "Korrigieren", "title": "Rechtschreibung und Grammatik prufen", "changed": "Korrigiert", "clean": "Keine Fehler", "error": "Konnte nicht korrigieren"},
                photoTranslate: {"hint": "Auf Schild oder Menu zielen und auslosen", "processing": "Lese und ubersetze...", "original": "Erkannter Text", "translation": "In deiner Sprache", "listen": "Anhoren", "stop": "Stoppen", "copy": "Kopieren", "sendToChat": "An Chat senden", "another": "Anderes Foto", "retry": "Erneut versuchen", "close": "Schliessen", "errCamera": "Zugriff auf Kamera nicht moglich", "errProcess": "Foto konnte nicht verarbeitet werden", "noText": "Kein Text erkannt", "attachLabel": "Fotoübersetzer"}
        },
        profile: {
            title: 'Profil bearbeiten', changePhoto: '📷 Foto ändern',
            name: 'Name', namePlaceholder: 'Ihr Name',
            status: 'Status', statusPlaceholder: 'Hey, ich benutze Kaixo!',
            language: 'Sprache', languagePlaceholder: 'z.B.: Deutsch, Englisch...',
            region: 'Region', regionPlaceholder: 'Land oder Stadt',
            voice: 'Nachrichtenstimme', female: '👩 Weiblich', male: '👨 Männlich',
            save: 'Änderungen speichern', saving: 'Speichern...',
            error: { nameEmpty: 'Name darf nicht leer sein', save: 'Fehler beim Speichern', connection: 'Fehler beim Verbinden mit dem Server' }
        },
        group: {
            participants: 'Teilnehmer', add: '➕ Hinzufügen', leave: '🚪 Gruppe verlassen',
            delete: '🗑️ Gruppe löschen', loading: 'Kontakte laden...',
            noContacts: 'Alle Kontakte sind bereits in dieser Gruppe',
            selected: 'ausgewählt', addBtn: 'Hinzufügen',
            leaveConfirm: 'Gruppe verlassen?', leaveWarning: 'Du kannst keine Nachrichten mehr sehen.',
            deleteConfirm: 'Diese Aktion kann NICHT rückgängig gemacht werden.',
            deleteConfirmText: 'Bist du sicher?',
            transferAdmin: 'Administration übertragen', transferDesc: 'Du musst einen Admin ernennen bevor du gehst.',
            transferAndLeave: 'Übertragen und Verlassen', creator: '👑 Ersteller', admin: '⭐ Admin',
            cancel: 'Abbrechen', danger: 'Gruppe verlassen', yesDelete: 'Ja, Gruppe löschen',
            error: { noContacts: 'Wähle mindestens einen Kontakt', add: 'Fehler beim Hinzufügen', remove: 'Fehler beim Entfernen', leave: 'Fehler beim Verlassen', delete: 'Fehler beim Löschen', removeCreator: 'Du kannst den Ersteller nicht entfernen' }
        },
        createGroup: {
            title: 'Neue Gruppe erstellen', groupName: 'Gruppenname',
            groupNamePlaceholder: 'z.B.: Freunde, Familie, Arbeit...',
            selectMembers: 'Mitglieder auswählen', noUsers: 'Keine Benutzer verfügbar',
            cancel: 'Abbrechen', creating: 'Erstellen...', create: 'Gruppe erstellen',
            error: { noName: 'Bitte Gruppenname eingeben', noMembers: 'Wähle mindestens einen Kontakt', create: 'Fehler beim Erstellen der Gruppe' }
        },
        doc: {
            noPreview: 'Dieser Dateityp hat keine Textvorschau.',
            downloadMsg: 'Du kannst sie herunterladen, um sie anzuzeigen.',
            sendTo: 'Senden an...', send: 'Senden', cancel: 'Abbrechen'
        }
    },
    pt: {
        app: { subtitle: 'Mensagens sem barreiras de idioma' },
        login: {
            signin: 'Entrar', signup: 'Registrar',
            phone: 'Telefone', phonePlaceholder: '+55 11 9 0000-0000',
            password: 'Senha', passwordPlaceholder: '••••••••',
            passwordMin: 'Mínimo 6 caracteres',
            repeatPassword: 'Repetir senha', repeatPasswordPlaceholder: 'Repita sua senha',
            name: 'Nome', namePlaceholder: 'Seu nome',
            language: 'Idioma', languagePlaceholder: 'ex: português, inglês...',
            region: 'Região', regionPlaceholder: 'País ou cidade',
            entering: 'Entrando...', enter: 'Entrar',
            creating: 'Registrando...', createAccount: 'Criar conta',
            error: {
                fillRequired: 'Preencha todos os campos obrigatórios',
                passwordMismatch: 'As senhas não coincidem',
                passwordLength: 'A senha deve ter pelo menos 6 caracteres',
                phonePassword: 'Telefone ou senha incorretos',
                registerFailed: 'Erro ao registrar',
                connection: 'Erro ao conectar ao servidor',
                phoneRequired: 'Insira seu telefone e senha'
            }
        },
        conv: {
            loading: 'Carregando...', createGroup: 'Criar grupo', logout: 'Sair',
            noLongerMember: 'Não é mais membro', noMessages: 'Sem mensagens',
            contacts: 'Contatos', noUsers: 'Nenhum usuário disponível'
        },
        chat: {
            loading: 'Carregando mensagens...', selectConversation: 'Selecione uma conversa para começar',
            searchPlaceholder: 'Pesquisar na conversa...', members: 'membros',
            online: 'Online', typingPlaceholder: 'Escreva em', send: 'Enviar',
            sendImage: 'Enviar imagem', sendVideo: 'Enviar vídeo', sendAudio: 'Enviar áudio',
            sendDocument: 'Enviar documento', processing: 'Processando vídeo...',
            translating: 'Traduzindo e enviando...', sending: 'Enviando...',
            recording: 'Gravando...', deleted: 'Esta mensagem foi excluída',
            addCaption: 'Adicionar mensagem (opcional)...',
            clearChatConfirm: 'Limpar chat? As mensagens só serão apagadas para você.',
            deleteConvConfirm: 'Excluir esta conversa? Não poderá recuperá-la.',
            leaveGroupConfirm: 'Sair do grupo?', leaveGroupWarning: 'Você não poderá mais ver mensagens.',
            leaveGroupAdmin: '⚠️ Você é o único admin. Transfira antes de sair.',
            leave: 'Sair do grupo', cancel: 'Cancelar',
            forward: 'Encaminhar', forwardMsg: 'Encaminhar mensagem',
            deleteMsg: 'Excluir mensagem', deleteForMe: 'Excluir para mim', deleteForAll: 'Excluir para todos',
            formerMember: 'Você não é mais membro deste grupo',
            conversations: 'Conversas', groups: 'Grupos', loading2: 'Carregando...',
            searchMenu: '🔍 Pesquisar', addMember: '➕ Adicionar membro', groupInfo: 'ℹ️ Info do grupo',
            contactInfo: 'ℹ️ Info do contato', muteNotif: '🔕 Silenciar notificações',
            unmuteNotif: '🔔 Ativar notificações', addFav: '⭐ Adicionar aos favoritos',
            removeFav: '★ Remover dos favoritos', block: '🚫 Bloquear', unblock: '✅ Desbloquear',
            clearChat: '🗑️ Limpar chat', deleteChat: '❌ Excluir conversa', leaveGroupMenu: '🚪 Sair do grupo',
            pause: '⏸ Pausar', stop: '⏹ Parar', continue: '▶ Continuar',
            attach: '📎 Anexar', gallery: '🖼️ Galeria', document: '📄 Documento',
            camera: '📷 Câmera', recordVideo: '🎥 Gravar vídeo', audio: '🎙️ Áudio',
            voiceTranslation: 'Tradução de voz em tempo real', listening: '🌐 Ouvindo...',
            stopRecording: '⏹ Parar', errorSendMessage: 'Erro ao enviar mensagem',
            errorSendVideo: 'Erro ao enviar vídeo', errorSendDocument: 'Erro ao enviar documento',
            errorCamera: 'Não foi possível acessar a câmera', errorMic: 'Não foi possível acessar o microfone.',
            errorVoice: 'Seu navegador não suporta reconhecimento de voz',
            capture: '📷 Capturar', record: '🔴 Gravar', stopBtn: '⏹ Parar', cancelBtn: '✕ Cancelar',
            contactCard: {
                type: 'Contacto KAIXO',
                add: 'Adicionar aos contactos',
                close: 'Fechar',
                labelPhone: 'Telefone',
                labelEmail: 'E-mail',
                labelLanguage: 'Idioma',
                labelPlace: 'Local',
                noName: '(sem nome)',
                fallbackName: 'Contacto KAIXO',
                errNoPhone: 'Sem telefone — não é possível guardar',
                errMobileOnly: 'Esta ação só funciona no app móvel',
                errPermDenied: 'Permissão de contactos negada',
                savedSuffix: 'guardado na tua agenda',
                errSavePrefix: 'Não foi possível guardar',
                viewProfile: 'Ver perfil'
            },
                correct: {"button": "Corrigir", "title": "Corrigir ortografia e gramatica", "changed": "Corrigido", "clean": "Sem erros", "error": "Nao foi possivel corrigir"},
                photoTranslate: {"hint": "Aponta a um cartaz ou menu e dispara", "processing": "A ler e traduzir...", "original": "Texto detetado", "translation": "No teu idioma", "listen": "Ouvir", "stop": "Parar", "copy": "Copiar", "sendToChat": "Enviar para o chat", "another": "Outra foto", "retry": "Tentar de novo", "close": "Fechar", "errCamera": "Nao foi possivel aceder a camara", "errProcess": "Erro ao processar a foto", "noText": "Nenhum texto detetado", "attachLabel": "Fototradutor"}
        },
        profile: {
            title: 'Editar perfil', changePhoto: '📷 Alterar foto',
            name: 'Nome', namePlaceholder: 'Seu nome',
            status: 'Status', statusPlaceholder: 'Ei, estou usando o Kaixo!',
            language: 'Idioma', languagePlaceholder: 'ex: português, inglês...',
            region: 'Região', regionPlaceholder: 'País ou cidade',
            voice: 'Voz para mensagens', female: '👩 Feminina', male: '👨 Masculina',
            save: 'Salvar alterações', saving: 'Salvando...',
            error: { nameEmpty: 'O nome não pode estar vazio', save: 'Erro ao salvar', connection: 'Erro ao conectar ao servidor' }
        },
        group: {
            participants: 'Participantes', add: '➕ Adicionar', leave: '🚪 Sair do Grupo',
            delete: '🗑️ Excluir Grupo', loading: 'Carregando contatos...',
            noContacts: 'Todos os seus contatos já estão neste grupo',
            selected: 'selecionados', addBtn: 'Adicionar',
            leaveConfirm: 'Sair do grupo?', leaveWarning: 'Você não poderá mais ver mensagens.',
            deleteConfirm: 'Esta ação NÃO pode ser desfeita. O grupo será excluído para TODOS.',
            deleteConfirmText: 'Tem certeza que deseja continuar?',
            transferAdmin: 'Transferir Administração', transferDesc: 'Você deve nomear outro admin antes de sair.',
            transferAndLeave: 'Transferir e Sair', creator: '👑 Criador', admin: '⭐ Admin',
            cancel: 'Cancelar', danger: 'Sair do Grupo', yesDelete: 'Sim, Excluir Grupo',
            error: { noContacts: 'Selecione pelo menos um contato', add: 'Erro ao adicionar membros', remove: 'Erro ao remover membro', leave: 'Erro ao sair do grupo', delete: 'Erro ao excluir grupo', removeCreator: 'Você não pode remover o criador do grupo' }
        },
        createGroup: {
            title: 'Criar Novo Grupo', groupName: 'Nome do grupo',
            groupNamePlaceholder: 'Ex: Amigos, Família, Trabalho...',
            selectMembers: 'Selecionar membros', noUsers: 'Nenhum usuário disponível',
            cancel: 'Cancelar', creating: 'Criando...', create: 'Criar Grupo',
            error: { noName: 'Por favor insira um nome para o grupo', noMembers: 'Selecione pelo menos um contato', create: 'Erro ao criar grupo' }
        },
        doc: {
            noPreview: 'Este tipo de arquivo não tem pré-visualização de texto.',
            downloadMsg: 'Você pode baixá-lo para visualizá-lo.',
            sendTo: 'Enviar para...', send: 'Enviar', cancel: 'Cancelar'
        }
    },
    it: {
        app: { subtitle: 'Messaggistica senza barriere linguistiche' },
        login: {
            signin: 'Accedi', signup: 'Registrati',
            phone: 'Telefono', phonePlaceholder: '+39 600 000 0000',
            password: 'Password', passwordPlaceholder: '••••••••',
            passwordMin: 'Almeno 6 caratteri',
            repeatPassword: 'Ripeti password', repeatPasswordPlaceholder: 'Ripeti la password',
            name: 'Nome', namePlaceholder: 'Il tuo nome',
            language: 'Lingua', languagePlaceholder: 'es: italiano, inglese...',
            region: 'Regione', regionPlaceholder: 'Paese o città',
            entering: 'Accesso...', enter: 'Accedi',
            creating: 'Registrazione...', createAccount: 'Crea account',
            error: {
                fillRequired: 'Compila tutti i campi obbligatori',
                passwordMismatch: 'Le password non coincidono',
                passwordLength: 'La password deve avere almeno 6 caratteri',
                phonePassword: 'Telefono o password errati',
                registerFailed: 'Errore durante la registrazione',
                connection: 'Errore di connessione al server',
                phoneRequired: 'Inserisci telefono e password'
            }
        },
        conv: {
            loading: 'Caricamento...', createGroup: 'Crea gruppo', logout: 'Disconnetti',
            noLongerMember: 'Non più membro', noMessages: 'Nessun messaggio',
            contacts: 'Contatti', noUsers: 'Nessun utente disponibile'
        },
        chat: {
            loading: 'Caricamento messaggi...', selectConversation: 'Seleziona una conversazione per iniziare',
            searchPlaceholder: 'Cerca nella conversazione...', members: 'membri',
            online: 'Online', typingPlaceholder: 'Scrivi in', send: 'Invia',
            sendImage: 'Invia immagine', sendVideo: 'Invia video', sendAudio: 'Invia audio',
            sendDocument: 'Invia documento', processing: 'Elaborazione video...',
            translating: 'Traduzione e invio...', sending: 'Invio...',
            recording: 'Registrazione...', deleted: 'Questo messaggio è stato eliminato',
            addCaption: 'Aggiungi un messaggio (opzionale)...',
            clearChatConfirm: 'Svuotare la chat? I messaggi saranno eliminati solo per te.',
            deleteConvConfirm: 'Eliminare questa conversazione? Non potrai recuperarla.',
            leaveGroupConfirm: 'Uscire dal gruppo?', leaveGroupWarning: 'Non potrai più vedere i messaggi.',
            leaveGroupAdmin: '⚠️ Sei il solo admin. Trasferisci prima di uscire.',
            leave: 'Esci dal gruppo', cancel: 'Annulla',
            forward: 'Inoltra', forwardMsg: 'Inoltra messaggio',
            deleteMsg: 'Elimina messaggio', deleteForMe: 'Elimina per me', deleteForAll: 'Elimina per tutti',
            formerMember: 'Non sei più membro di questo gruppo',
            conversations: 'Conversazioni', groups: 'Gruppi', loading2: 'Caricamento...',
            searchMenu: '🔍 Cerca', addMember: '➕ Aggiungi membro', groupInfo: 'ℹ️ Info gruppo',
            contactInfo: 'ℹ️ Info contatto', muteNotif: '🔕 Silenzia notifiche',
            unmuteNotif: '🔔 Attiva notifiche', addFav: '⭐ Aggiungi ai preferiti',
            removeFav: '★ Rimuovi dai preferiti', block: '🚫 Blocca', unblock: '✅ Sblocca',
            clearChat: '🗑️ Svuota chat', deleteChat: '❌ Elimina conversazione', leaveGroupMenu: '🚪 Esci dal gruppo',
            pause: '⏸ Pausa', stop: '⏹ Stop', continue: '▶ Continua',
            attach: '📎 Allega', gallery: '🖼️ Galleria', document: '📄 Documento',
            camera: '📷 Fotocamera', recordVideo: '🎥 Registra video', audio: '🎙️ Audio',
            voiceTranslation: 'Traduzione vocale in tempo reale', listening: '🌐 Ascolto...',
            stopRecording: '⏹ Stop', errorSendMessage: "Errore nell'invio del messaggio",
            errorSendVideo: "Errore nell'invio del video", errorSendDocument: "Errore nell'invio del documento",
            errorCamera: 'Impossibile accedere alla fotocamera', errorMic: 'Impossibile accedere al microfono.',
            errorVoice: 'Il browser non supporta il riconoscimento vocale',
            capture: '📷 Cattura', record: '🔴 Registra', stopBtn: '⏹ Stop', cancelBtn: '✕ Annulla',
            contactCard: {
                type: 'Contatto KAIXO',
                add: 'Aggiungi ai contatti',
                close: 'Chiudi',
                labelPhone: 'Telefono',
                labelEmail: 'Email',
                labelLanguage: 'Lingua',
                labelPlace: 'Luogo',
                noName: '(senza nome)',
                fallbackName: 'Contatto KAIXO',
                errNoPhone: 'Nessun telefono — impossibile salvare',
                errMobileOnly: 'Questa azione funziona solo nell’app mobile',
                errPermDenied: 'Permesso contatti negato',
                savedSuffix: 'salvato nella rubrica',
                errSavePrefix: 'Impossibile salvare',
                viewProfile: 'Vedi profilo'
            },
                correct: {"button": "Correggi", "title": "Correggi ortografia e grammatica", "changed": "Corretto", "clean": "Nessun errore", "error": "Impossibile correggere"},
                photoTranslate: {"hint": "Inquadra un cartello o menu e scatta", "processing": "Lettura e traduzione...", "original": "Testo rilevato", "translation": "Nella tua lingua", "listen": "Ascolta", "stop": "Ferma", "copy": "Copia", "sendToChat": "Invia in chat", "another": "Altra foto", "retry": "Riprova", "close": "Chiudi", "errCamera": "Impossibile accedere alla fotocamera", "errProcess": "Errore durante l elaborazione", "noText": "Nessun testo rilevato", "attachLabel": "Fototraduttore"}
        },
        profile: {
            title: 'Modifica profilo', changePhoto: '📷 Cambia foto',
            name: 'Nome', namePlaceholder: 'Il tuo nome',
            status: 'Stato', statusPlaceholder: 'Hey, sto usando Kaixo!',
            language: 'Lingua', languagePlaceholder: 'es: italiano, inglese...',
            region: 'Regione', regionPlaceholder: 'Paese o città',
            voice: 'Voce per i messaggi', female: '👩 Femminile', male: '👨 Maschile',
            save: 'Salva modifiche', saving: 'Salvataggio...',
            error: { nameEmpty: 'Il nome non può essere vuoto', save: 'Errore durante il salvataggio', connection: 'Errore di connessione al server' }
        },
        group: {
            participants: 'Partecipanti', add: '➕ Aggiungi', leave: '🚪 Esci dal Gruppo',
            delete: '🗑️ Elimina Gruppo', loading: 'Caricamento contatti...',
            noContacts: 'Tutti i tuoi contatti sono già in questo gruppo',
            selected: 'selezionati', addBtn: 'Aggiungi',
            leaveConfirm: 'Uscire dal gruppo?', leaveWarning: 'Non potrai più vedere i messaggi.',
            deleteConfirm: 'Questa azione NON può essere annullata.',
            deleteConfirmText: 'Sei sicuro di voler continuare?',
            transferAdmin: 'Trasferisci Amministrazione', transferDesc: 'Devi nominare un altro admin prima di uscire.',
            transferAndLeave: 'Trasferisci ed Esci', creator: '👑 Creatore', admin: '⭐ Admin',
            cancel: 'Annulla', danger: 'Esci dal Gruppo', yesDelete: 'Sì, Elimina Gruppo',
            error: { noContacts: 'Seleziona almeno un contatto', add: "Errore nell'aggiunta", remove: "Errore nella rimozione", leave: "Errore nell'uscita", delete: "Errore nell'eliminazione", removeCreator: 'Non puoi rimuovere il creatore' }
        },
        createGroup: {
            title: 'Crea Nuovo Gruppo', groupName: 'Nome del gruppo',
            groupNamePlaceholder: 'Es: Amici, Famiglia, Lavoro...',
            selectMembers: 'Seleziona membri', noUsers: 'Nessun utente disponibile',
            cancel: 'Annulla', creating: 'Creazione...', create: 'Crea Gruppo',
            error: { noName: 'Inserisci un nome per il gruppo', noMembers: 'Seleziona almeno un contatto', create: 'Errore nella creazione del gruppo' }
        },
        doc: {
            noPreview: 'Questo tipo di file non ha anteprima testo.',
            downloadMsg: 'Puoi scaricarlo per visualizzarlo.',
            sendTo: 'Invia a...', send: 'Invia', cancel: 'Annulla'
        }
    },
    eu: {
        app: { subtitle: 'Mezularitza hizkuntza oztopoak gabe' },
        login: {
            signin: 'Hasi saioa', signup: 'Erregistratu',
            phone: 'Telefonoa', phonePlaceholder: '+34 600 000 000',
            password: 'Pasahitza', passwordPlaceholder: '••••••••',
            passwordMin: 'Gutxienez 6 karaktere',
            repeatPassword: 'Errepikatu pasahitza', repeatPasswordPlaceholder: 'Errepikatu pasahitza',
            name: 'Izena', namePlaceholder: 'Zure izena',
            language: 'Hizkuntza', languagePlaceholder: 'ad.: euskara, gaztelania...',
            region: 'Eskualdea', regionPlaceholder: 'Herrialdea edo hiria',
            entering: 'Sartzen...', enter: 'Sartu',
            creating: 'Erregistratzen...', createAccount: 'Kontua sortu',
            error: {
                fillRequired: 'Bete beharrezko eremu guztiak',
                passwordMismatch: 'Pasahitzak ez datoz bat',
                passwordLength: 'Pasahitzak gutxienez 6 karaktere behar ditu',
                phonePassword: 'Telefonoa edo pasahitza okerrak',
                registerFailed: 'Errorea erregistratzean',
                connection: 'Errorea zerbitzariarekin konektatzean',
                phoneRequired: 'Sartu zure telefonoa eta pasahitza'
            }
        },
        conv: {
            loading: 'Kargatzen...', createGroup: 'Taldea sortu', logout: 'Saioa itxi',
            noLongerMember: 'Ez zara kide', noMessages: 'Mezurik gabe',
            contacts: 'Kontaktuak', noUsers: 'Ez dago erabiltzailerik'
        },
        chat: {
            loading: 'Mezuak kargatzen...', selectConversation: 'Hautatu elkarrizketa bat hasteko',
            searchPlaceholder: 'Bilatu elkarrizketan...', members: 'kide',
            online: 'Linean', typingPlaceholder: 'Idatzi', send: 'Bidali',
            sendImage: 'Bidali irudia', sendVideo: 'Bidali bideoa', sendAudio: 'Bidali audioa',
            sendDocument: 'Bidali dokumentua', processing: 'Bideoa prozesatzen...',
            translating: 'Itzultzen eta bidaltzen...', sending: 'Bidaltzen...',
            recording: 'Grabatzen...', deleted: 'Mezu hau ezabatu da',
            addCaption: 'Gehitu mezu bat (aukerakoa)...',
            clearChatConfirm: 'Txata garbitu? Mezuak zure kabuz bakarrik ezabatuko dira.',
            deleteConvConfirm: 'Ezabatu elkarrizketa hau? Ezin izango duzu berreskuratu.',
            leaveGroupConfirm: 'Taldea utzi?', leaveGroupWarning: 'Ezin izango dituzu mezuak ikusi.',
            leaveGroupAdmin: '⚠️ Administrari bakarra zara. Transferitu irten aurretik.',
            leave: 'Taldea utzi', cancel: 'Utzi',
            forward: 'Birbidali', forwardMsg: 'Mezu birbidaltzea',
            deleteMsg: 'Mezua ezabatu', deleteForMe: 'Ezabatu niretzat', deleteForAll: 'Ezabatu guztientzat',
            formerMember: 'Ez zara talde honetako kide',
            conversations: 'Elkarrizketak', groups: 'Taldeak', loading2: 'Kargatzen...',
            searchMenu: '🔍 Bilatu', addMember: '➕ Kide gehitu', groupInfo: 'ℹ️ Taldearen info',
            contactInfo: 'ℹ️ Kontaktuaren info', muteNotif: '🔕 Jakinarazpenak isilarazi',
            unmuteNotif: '🔔 Jakinarazpenak aktibatu', addFav: '⭐ Gogokoen gehitu',
            removeFav: '★ Gogokoetatik kendu', block: '🚫 Blokeatu', unblock: '✅ Desblokeatu',
            clearChat: '🗑️ Txata garbitu', deleteChat: '❌ Elkarrizketa ezabatu', leaveGroupMenu: '🚪 Taldea utzi',
            pause: '⏸ Pausatu', stop: '⏹ Gelditu', continue: '▶ Jarraitu',
            attach: '📎 Erantsi', gallery: '🖼️ Galeria', document: '📄 Dokumentua',
            camera: '📷 Kamera', recordVideo: '🎥 Bideoa grabatu', audio: '🎙️ Audioa',
            voiceTranslation: 'Ahots itzulpena denbora errealean', listening: '🌐 Entzuten...',
            stopRecording: '⏹ Gelditu', errorSendMessage: 'Errorea mezua bidaltzean',
            errorSendVideo: 'Errorea bideoa bidaltzean', errorSendDocument: 'Errorea dokumentua bidaltzean',
            errorCamera: 'Ezin da kamera atzitu', errorMic: 'Ezin da mikrofonoa atzitu.',
            errorVoice: 'Zure nabigatzaileak ez du ahots ezagutza onartzen',
            capture: '📷 Argazkia atera', record: '🔴 Grabatu', stopBtn: '⏹ Gelditu', cancelBtn: '✕ Utzi',
            contactCard: {
                type: 'KAIXO kontaktua',
                add: 'Gehitu kontaktuetara',
                close: 'Itxi',
                labelPhone: 'Telefonoa',
                labelEmail: 'Emaila',
                labelLanguage: 'Hizkuntza',
                labelPlace: 'Tokia',
                noName: '(izenik gabe)',
                fallbackName: 'KAIXO kontaktua',
                errNoPhone: 'Telefonorik gabe — ezin da gorde',
                errMobileOnly: 'Ekintza honek mugikorreko app-ean bakarrik funtzionatzen du',
                errPermDenied: 'Kontaktuen baimena ukatu da',
                savedSuffix: 'kontaktuetan gorde da',
                errSavePrefix: 'Ezin izan da gorde',
                viewProfile: 'Ikusi profila'
            },
                correct: {"button": "Zuzendu", "title": "Zuzendu ortografia eta gramatika", "changed": "Zuzenduta", "clean": "Akatsik gabe", "error": "Ezin izan da zuzendu"},
                photoTranslate: {"hint": "Apuntatu kartel edo menu bati eta atera", "processing": "Irakurtzen eta itzultzen...", "original": "Detektatutako testua", "translation": "Zure hizkuntzan", "listen": "Entzun", "stop": "Gelditu", "copy": "Kopiatu", "sendToChat": "Bidali txatera", "another": "Beste argazki bat", "retry": "Berriro saiatu", "close": "Itxi", "errCamera": "Ezin da kamerara sartu", "errProcess": "Errorea argazkia prozesatzean", "noText": "Ez da testurik antzeman irudian", "attachLabel": "Argazki itzultzailea"}
        },
        profile: {
            title: 'Profila editatu', changePhoto: '📷 Argazkia aldatu',
            name: 'Izena', namePlaceholder: 'Zure izena',
            status: 'Egoera', statusPlaceholder: 'Kaixo, Kaixo erabiltzen ari naiz!',
            language: 'Hizkuntza', languagePlaceholder: 'ad.: euskara, gaztelania...',
            region: 'Eskualdea', regionPlaceholder: 'Herrialdea edo hiria',
            voice: 'Mezuen ahotsa', female: '👩 Emakumezkoa', male: '👨 Gizonezkoa',
            save: 'Aldaketak gorde', saving: 'Gordetzen...',
            error: { nameEmpty: 'Izena ezin da hutsik egon', save: 'Errorea gordetzean', connection: 'Errorea zerbitzariarekin konektatzean' }
        },
        group: {
            participants: 'Partaideak', add: '➕ Gehitu', leave: '🚪 Taldea Utzi',
            delete: '🗑️ Taldea Ezabatu', loading: 'Kontaktuak kargatzen...',
            noContacts: 'Zure kontaktu guztiak dagoeneko talde honetan daude',
            selected: 'hautatuta', addBtn: 'Gehitu',
            leaveConfirm: 'Taldea utzi?', leaveWarning: 'Ezin izango dituzu mezuak ikusi.',
            deleteConfirm: 'Ekintza hau EZIN da desegin. Taldea KIDE GUZTIENTZAT ezabatuko da.',
            deleteConfirmText: 'Ziur zaude jarraitu nahi duzula?',
            transferAdmin: 'Administrazioa Transferitu', transferDesc: 'Beste admin bat izendatu behar duzu irten aurretik.',
            transferAndLeave: 'Transferitu eta Utzi', creator: '👑 Sortzailea', admin: '⭐ Admin',
            cancel: 'Utzi', danger: 'Taldea Utzi', yesDelete: 'Bai, Taldea Ezabatu',
            error: { noContacts: 'Hautatu gutxienez kontaktu bat', add: 'Errorea kideak gehitzean', remove: 'Errorea kidea kentzeaen', leave: 'Errorea taldea uzteaen', delete: 'Errorea taldea ezabatzeaen', removeCreator: 'Ezin duzu sortzailea kendu' }
        },
        createGroup: {
            title: 'Talde Berria Sortu', groupName: 'Taldearen izena',
            groupNamePlaceholder: 'Ad.: Lagunak, Familia, Lana...',
            selectMembers: 'Kideak hautatu', noUsers: 'Ez dago erabiltzailerik',
            cancel: 'Utzi', creating: 'Sortzen...', create: 'Taldea Sortu',
            error: { noName: 'Sartu taldearen izena', noMembers: 'Hautatu gutxienez kontaktu bat', create: 'Errorea taldea sortzeaen' }
        },
        doc: {
            noPreview: 'Fitxategi mota honek ez du testu aurreikuspen bat.',
            downloadMsg: 'Deskargatu dezakezu ikusteko.',
            sendTo: 'Bidali hona...', send: 'Bidali', cancel: 'Utzi'
        }
    },
    zh: {
        app: { subtitle: '无语言障碍的消息传递' },
        login: {
            signin: '登录', signup: '注册',
            phone: '电话', phonePlaceholder: '+86 138 0000 0000',
            password: '密码', passwordPlaceholder: '••••••••',
            passwordMin: '至少6个字符',
            repeatPassword: '重复密码', repeatPasswordPlaceholder: '重复您的密码',
            name: '姓名', namePlaceholder: '您的姓名',
            language: '语言', languagePlaceholder: '例如：中文、英文...',
            region: '地区', regionPlaceholder: '国家或城市',
            entering: '登录中...', enter: '登录',
            creating: '注册中...', createAccount: '创建账户',
            error: {
                fillRequired: '请填写所有必填字段',
                passwordMismatch: '密码不匹配',
                passwordLength: '密码至少需要6个字符',
                phonePassword: '电话或密码错误',
                registerFailed: '注册失败',
                connection: '连接服务器时出错',
                phoneRequired: '请输入您的电话和密码'
            }
        },
        conv: {
            loading: '加载中...', createGroup: '创建群组', logout: '退出登录',
            noLongerMember: '不再是成员', noMessages: '没有消息',
            contacts: '联系人', noUsers: '没有可用用户'
        },
        chat: {
            loading: '加载消息...', selectConversation: '选择对话开始聊天',
            searchPlaceholder: '在对话中搜索...', members: '成员',
            online: '在线', typingPlaceholder: '用以下语言输入', send: '发送',
            sendImage: '发送图片', sendVideo: '发送视频', sendAudio: '发送音频',
            sendDocument: '发送文件', processing: '处理视频中...',
            translating: '翻译并发送中...', sending: '发送中...',
            recording: '录制中...', deleted: '此消息已删除',
            addCaption: '添加消息（可选）...',
            clearChatConfirm: '清空聊天？消息仅对您删除。',
            deleteConvConfirm: '删除此对话？将无法恢复。',
            leaveGroupConfirm: '离开群组？', leaveGroupWarning: '您将无法再看到消息。',
            leaveGroupAdmin: '⚠️ 您是唯一管理员。离开前请转移权限。',
            leave: '离开群组', cancel: '取消',
            forward: '转发', forwardMsg: '转发消息',
            deleteMsg: '删除消息', deleteForMe: '仅为我删除', deleteForAll: '为所有人删除',
            formerMember: '您不再是此群组的成员',
            conversations: '对话', groups: '群组', loading2: '加载中...',
            searchMenu: '🔍 搜索', addMember: '➕ 添加成员', groupInfo: 'ℹ️ 群组信息',
            contactInfo: 'ℹ️ 联系人信息', muteNotif: '🔕 静音通知',
            unmuteNotif: '🔔 启用通知', addFav: '⭐ 添加到收藏',
            removeFav: '★ 从收藏中移除', block: '🚫 屏蔽', unblock: '✅ 解除屏蔽',
            clearChat: '🗑️ 清空聊天', deleteChat: '❌ 删除对话', leaveGroupMenu: '🚪 离开群组',
            pause: '⏸ 暂停', stop: '⏹ 停止', continue: '▶ 继续',
            attach: '📎 附件', gallery: '🖼️ 相册', document: '📄 文件',
            camera: '📷 相机', recordVideo: '🎥 录制视频', audio: '🎙️ 音频',
            voiceTranslation: '实时语音翻译', listening: '🌐 听取中...',
            stopRecording: '⏹ 停止', errorSendMessage: '发送消息时出错',
            errorSendVideo: '发送视频时出错', errorSendDocument: '发送文件时出错',
            errorCamera: '无法访问摄像头', errorMic: '无法访问麦克风。',
            errorVoice: '您的浏览器不支持语音识别',
            capture: '📷 拍照', record: '🔴 录制', stopBtn: '⏹ 停止', cancelBtn: '✕ 取消',
            contactCard: {
                type: 'KAIXO 联系人',
                add: '添加到联系人',
                close: '关闭',
                labelPhone: '电话',
                labelEmail: '邮箱',
                labelLanguage: '语言',
                labelPlace: '位置',
                noName: '(无姓名)',
                fallbackName: 'KAIXO 联系人',
                errNoPhone: '没有电话 — 无法保存',
                errMobileOnly: '此操作仅在移动应用中有效',
                errPermDenied: '联系人权限被拒绝',
                savedSuffix: '已保存到您的通讯录',
                errSavePrefix: '无法保存',
                viewProfile: '查看资料'
            },
                correct: {"button": "纠正", "title": "纠正拼写和语法", "changed": "已纠正", "clean": "无错误", "error": "无法纠正"},
                photoTranslate: {"hint": "对准标牌或菜单拍摄", "processing": "正在识别并翻译...", "original": "检测到的文本", "translation": "以您的语言", "listen": "朗读", "stop": "停止", "copy": "复制", "sendToChat": "发送到聊天", "another": "再拍一张", "retry": "重试", "close": "关闭", "errCamera": "无法访问相机", "errProcess": "无法处理照片", "noText": "图像中未检测到文字", "attachLabel": "照片翻译"}
        },
        profile: {
            title: '编辑资料', changePhoto: '📷 更换照片',
            name: '姓名', namePlaceholder: '您的姓名',
            status: '状态', statusPlaceholder: '嗨，我在使用Kaixo！',
            language: '语言', languagePlaceholder: '例如：中文、英文...',
            region: '地区', regionPlaceholder: '国家或城市',
            voice: '消息语音', female: '👩 女声', male: '👨 男声',
            save: '保存更改', saving: '保存中...',
            error: { nameEmpty: '姓名不能为空', save: '保存时出错', connection: '连接服务器时出错' }
        },
        group: {
            participants: '参与者', add: '➕ 添加', leave: '🚪 离开群组',
            delete: '🗑️ 删除群组', loading: '加载联系人...',
            noContacts: '您的所有联系人已在此群组中',
            selected: '已选择', addBtn: '添加',
            leaveConfirm: '离开群组？', leaveWarning: '您将无法再看到消息。',
            deleteConfirm: '此操作无法撤销。群组将对所有成员删除。',
            deleteConfirmText: '您确定要继续吗？',
            transferAdmin: '转移管理权', transferDesc: '离开前必须指定另一位管理员。',
            transferAndLeave: '转移并离开', creator: '👑 创建者', admin: '⭐ 管理员',
            cancel: '取消', danger: '离开群组', yesDelete: '是的，删除群组',
            error: { noContacts: '至少选择一位联系人', add: '添加成员时出错', remove: '移除成员时出错', leave: '离开群组时出错', delete: '删除群组时出错', removeCreator: '无法移除群组创建者' }
        },
        createGroup: {
            title: '创建新群组', groupName: '群组名称',
            groupNamePlaceholder: '例如：朋友、家人、工作...',
            selectMembers: '选择成员', noUsers: '没有可用用户',
            cancel: '取消', creating: '创建中...', create: '创建群组',
            error: { noName: '请输入群组名称', noMembers: '至少选择一位联系人', create: '创建群组时出错' }
        },
        doc: {
            noPreview: '此文件类型没有文本预览。',
            downloadMsg: '您可以下载它来查看。',
            sendTo: '发送给...', send: '发送', cancel: '取消'
        }
    },
    ja: {
        app: { subtitle: '言語の壁なしのメッセージング' },
        login: {
            signin: 'ログイン', signup: '登録',
            phone: '電話番号', phonePlaceholder: '+81 90 0000 0000',
            password: 'パスワード', passwordPlaceholder: '••••••••',
            passwordMin: '最低6文字',
            repeatPassword: 'パスワードを繰り返す', repeatPasswordPlaceholder: 'パスワードを繰り返す',
            name: '名前', namePlaceholder: 'あなたの名前',
            language: '言語', languagePlaceholder: '例：日本語、英語...',
            region: '地域', regionPlaceholder: '国または都市',
            entering: 'ログイン中...', enter: 'ログイン',
            creating: '登録中...', createAccount: 'アカウントを作成',
            error: {
                fillRequired: '必須フィールドをすべて入力してください',
                passwordMismatch: 'パスワードが一致しません',
                passwordLength: 'パスワードは最低6文字必要です',
                phonePassword: '電話番号またはパスワードが正しくありません',
                registerFailed: '登録に失敗しました',
                connection: 'サーバーへの接続エラー',
                phoneRequired: '電話番号とパスワードを入力してください'
            }
        },
        conv: {
            loading: '読み込み中...', createGroup: 'グループを作成', logout: 'ログアウト',
            noLongerMember: 'もうメンバーではありません', noMessages: 'メッセージなし',
            contacts: '連絡先', noUsers: '利用可能なユーザーなし'
        },
        chat: {
            loading: 'メッセージを読み込み中...', selectConversation: '会話を選択してチャットを開始',
            searchPlaceholder: '会話内を検索...', members: 'メンバー',
            online: 'オンライン', typingPlaceholder: '入力言語', send: '送信',
            sendImage: '画像を送信', sendVideo: 'ビデオを送信', sendAudio: '音声を送信',
            sendDocument: 'ドキュメントを送信', processing: 'ビデオを処理中...',
            translating: '翻訳して送信中...', sending: '送信中...',
            recording: '録音中...', deleted: 'このメッセージは削除されました',
            addCaption: 'メッセージを追加（任意）...',
            clearChatConfirm: 'チャットをクリア？メッセージはあなただけに削除されます。',
            deleteConvConfirm: 'この会話を削除しますか？回復できません。',
            leaveGroupConfirm: 'グループを退出しますか？', leaveGroupWarning: 'メッセージを見ることができなくなります。',
            leaveGroupAdmin: '⚠️ あなたは唯一の管理者です。退出前に転送してください。',
            leave: 'グループを退出', cancel: 'キャンセル',
            forward: '転送', forwardMsg: 'メッセージを転送',
            deleteMsg: 'メッセージを削除', deleteForMe: '自分のみ削除', deleteForAll: '全員から削除',
            formerMember: 'このグループのメンバーではありません',
            conversations: '会話', groups: 'グループ', loading2: '読み込み中...',
            searchMenu: '🔍 検索', addMember: '➕ メンバーを追加', groupInfo: 'ℹ️ グループ情報',
            contactInfo: 'ℹ️ 連絡先情報', muteNotif: '🔕 通知をミュート',
            unmuteNotif: '🔔 通知を有効化', addFav: '⭐ お気に入りに追加',
            removeFav: '★ お気に入りから削除', block: '🚫 ブロック', unblock: '✅ ブロック解除',
            clearChat: '🗑️ チャットをクリア', deleteChat: '❌ 会話を削除', leaveGroupMenu: '🚪 グループを退出',
            pause: '⏸ 一時停止', stop: '⏹ 停止', continue: '▶ 続ける',
            attach: '📎 添付', gallery: '🖼️ ギャラリー', document: '📄 ドキュメント',
            camera: '📷 カメラ', recordVideo: '🎥 ビデオ録画', audio: '🎙️ 音声',
            voiceTranslation: 'リアルタイム音声翻訳', listening: '🌐 聴取中...',
            stopRecording: '⏹ 停止', errorSendMessage: 'メッセージ送信エラー',
            errorSendVideo: 'ビデオ送信エラー', errorSendDocument: 'ドキュメント送信エラー',
            errorCamera: 'カメラにアクセスできません', errorMic: 'マイクにアクセスできません。',
            errorVoice: 'ブラウザが音声認識をサポートしていません',
            capture: '📷 撮影', record: '🔴 録画', stopBtn: '⏹ 停止', cancelBtn: '✕ キャンセル',
            contactCard: {
                type: 'KAIXO 連絡先',
                add: '連絡先に追加',
                close: '閉じる',
                labelPhone: '電話',
                labelEmail: 'メール',
                labelLanguage: '言語',
                labelPlace: '場所',
                noName: '(名前なし)',
                fallbackName: 'KAIXO 連絡先',
                errNoPhone: '電話番号がないため保存できません',
                errMobileOnly: 'この操作はモバイルアプリでのみ動作します',
                errPermDenied: '連絡先の権限が拒否されました',
                savedSuffix: 'を連絡先に保存しました',
                errSavePrefix: '保存できませんでした',
                viewProfile: 'プロフィール表示'
            },
                correct: {"button": "校正", "title": "綴りと文法を校正", "changed": "校正済み", "clean": "エラーなし", "error": "校正できませんでした"},
                photoTranslate: {"hint": "看板やメニューに向けて撮影", "processing": "読み取り中・翻訳中...", "original": "検出されたテキスト", "translation": "あなたの言語で", "listen": "再生", "stop": "停止", "copy": "コピー", "sendToChat": "チャットに送信", "another": "もう一枚", "retry": "再試行", "close": "閉じる", "errCamera": "カメラにアクセスできません", "errProcess": "写真を処理できませんでした", "noText": "画像内にテキストが見つかりません", "attachLabel": "写真翻訳"}
        },
        profile: {
            title: 'プロフィールを編集', changePhoto: '📷 写真を変更',
            name: '名前', namePlaceholder: 'あなたの名前',
            status: 'ステータス', statusPlaceholder: 'こんにちは、Kaixoを使っています！',
            language: '言語', languagePlaceholder: '例：日本語、英語...',
            region: '地域', regionPlaceholder: '国または都市',
            voice: 'メッセージの声', female: '👩 女性', male: '👨 男性',
            save: '変更を保存', saving: '保存中...',
            error: { nameEmpty: '名前は空にできません', save: '保存エラー', connection: 'サーバーへの接続エラー' }
        },
        group: {
            participants: '参加者', add: '➕ 追加', leave: '🚪 グループを退出',
            delete: '🗑️ グループを削除', loading: '連絡先を読み込み中...',
            noContacts: 'すべての連絡先はすでにこのグループにいます',
            selected: '選択済み', addBtn: '追加',
            leaveConfirm: 'グループを退出しますか？', leaveWarning: 'メッセージを見ることができなくなります。',
            deleteConfirm: 'この操作は元に戻せません。全メンバーのグループが削除されます。',
            deleteConfirmText: '続行してよろしいですか？',
            transferAdmin: '管理者を転送', transferDesc: '退出前に別の管理者を指名する必要があります。',
            transferAndLeave: '転送して退出', creator: '👑 作成者', admin: '⭐ 管理者',
            cancel: 'キャンセル', danger: 'グループを退出', yesDelete: 'はい、グループを削除',
            error: { noContacts: '少なくとも1つの連絡先を選択', add: 'メンバー追加エラー', remove: 'メンバー削除エラー', leave: 'グループ退出エラー', delete: 'グループ削除エラー', removeCreator: 'グループ作成者を削除できません' }
        },
        createGroup: {
            title: '新しいグループを作成', groupName: 'グループ名',
            groupNamePlaceholder: '例：友達、家族、仕事...',
            selectMembers: 'メンバーを選択', noUsers: '利用可能なユーザーなし',
            cancel: 'キャンセル', creating: '作成中...', create: 'グループを作成',
            error: { noName: 'グループ名を入力してください', noMembers: '少なくとも1つの連絡先を選択', create: 'グループ作成エラー' }
        },
        doc: {
            noPreview: 'このファイルタイプにはテキストプレビューがありません。',
            downloadMsg: 'ダウンロードして表示できます。',
            sendTo: '送信先...', send: '送信', cancel: 'キャンセル'
        }
    },
    ar: {
        app: { subtitle: 'رسائل بدون حواجز لغوية' },
        login: {
            signin: 'تسجيل الدخول', signup: 'إنشاء حساب',
            phone: 'الهاتف', phonePlaceholder: '+966 50 000 0000',
            password: 'كلمة المرور', passwordPlaceholder: '••••••••',
            passwordMin: '6 أحرف على الأقل',
            repeatPassword: 'تكرار كلمة المرور', repeatPasswordPlaceholder: 'أعد كلمة المرور',
            name: 'الاسم', namePlaceholder: 'اسمك',
            language: 'اللغة', languagePlaceholder: 'مثال: العربية، الإنجليزية...',
            region: 'المنطقة', regionPlaceholder: 'البلد أو المدينة',
            entering: 'جارٍ الدخول...', enter: 'دخول',
            creating: 'جارٍ التسجيل...', createAccount: 'إنشاء حساب',
            error: {
                fillRequired: 'يرجى ملء جميع الحقول المطلوبة',
                passwordMismatch: 'كلمات المرور غير متطابقة',
                passwordLength: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
                phonePassword: 'رقم الهاتف أو كلمة المرور غير صحيحة',
                registerFailed: 'فشل التسجيل',
                connection: 'خطأ في الاتصال بالخادم',
                phoneRequired: 'أدخل رقم هاتفك وكلمة المرور'
            }
        },
        conv: {
            loading: 'جارٍ التحميل...', createGroup: 'إنشاء مجموعة', logout: 'تسجيل الخروج',
            noLongerMember: 'لست عضواً بعد الآن', noMessages: 'لا توجد رسائل',
            contacts: 'جهات الاتصال', noUsers: 'لا يوجد مستخدمون'
        },
        chat: {
            loading: 'جارٍ تحميل الرسائل...', selectConversation: 'اختر محادثة للبدء',
            searchPlaceholder: 'البحث في المحادثة...', members: 'أعضاء',
            online: 'متصل', typingPlaceholder: 'اكتب بـ', send: 'إرسال',
            sendImage: 'إرسال صورة', sendVideo: 'إرسال فيديو', sendAudio: 'إرسال صوت',
            sendDocument: 'إرسال مستند', processing: 'معالجة الفيديو...',
            translating: 'الترجمة والإرسال...', sending: 'جارٍ الإرسال...',
            recording: 'جارٍ التسجيل...', deleted: 'تم حذف هذه الرسالة',
            addCaption: 'أضف رسالة (اختياري)...',
            clearChatConfirm: 'مسح المحادثة؟ ستُحذف الرسائل لك فقط.',
            deleteConvConfirm: 'حذف هذه المحادثة؟ لن تتمكن من استردادها.',
            leaveGroupConfirm: 'مغادرة المجموعة؟', leaveGroupWarning: 'لن تتمكن من رؤية الرسائل.',
            leaveGroupAdmin: '⚠️ أنت المسؤول الوحيد. انقل الصلاحية قبل المغادرة.',
            leave: 'مغادرة المجموعة', cancel: 'إلغاء',
            forward: 'إعادة توجيه', forwardMsg: 'إعادة توجيه الرسالة',
            deleteMsg: 'حذف الرسالة', deleteForMe: 'حذف لي فقط', deleteForAll: 'حذف للجميع',
            formerMember: 'لست عضواً في هذه المجموعة',
            conversations: 'المحادثات', groups: 'المجموعات', loading2: 'جارٍ التحميل...',
            searchMenu: '🔍 بحث', addMember: '➕ إضافة عضو', groupInfo: 'ℹ️ معلومات المجموعة',
            contactInfo: 'ℹ️ معلومات جهة الاتصال', muteNotif: '🔕 كتم الإشعارات',
            unmuteNotif: '🔔 تفعيل الإشعارات', addFav: '⭐ إضافة للمفضلة',
            removeFav: '★ إزالة من المفضلة', block: '🚫 حظر', unblock: '✅ إلغاء الحظر',
            clearChat: '🗑️ مسح المحادثة', deleteChat: '❌ حذف المحادثة', leaveGroupMenu: '🚪 مغادرة المجموعة',
            pause: '⏸ إيقاف مؤقت', stop: '⏹ إيقاف', continue: '▶ متابعة',
            attach: '📎 مرفق', gallery: '🖼️ المعرض', document: '📄 مستند',
            camera: '📷 كاميرا', recordVideo: '🎥 تسجيل فيديو', audio: '🎙️ صوت',
            voiceTranslation: 'ترجمة صوتية فورية', listening: '🌐 جارٍ الاستماع...',
            stopRecording: '⏹ إيقاف', errorSendMessage: 'خطأ في إرسال الرسالة',
            errorSendVideo: 'خطأ في إرسال الفيديو', errorSendDocument: 'خطأ في إرسال المستند',
            errorCamera: 'لا يمكن الوصول إلى الكاميرا', errorMic: 'لا يمكن الوصول إلى الميكروفون.',
            errorVoice: 'متصفحك لا يدعم التعرف على الصوت',
            capture: '📷 التقاط', record: '🔴 تسجيل', stopBtn: '⏹ إيقاف', cancelBtn: '✕ إلغاء',
            contactCard: {
                type: 'جهة اتصال KAIXO',
                add: 'إضافة إلى جهات الاتصال',
                close: 'إغلاق',
                labelPhone: 'الهاتف',
                labelEmail: 'البريد الإلكتروني',
                labelLanguage: 'اللغة',
                labelPlace: 'الموقع',
                noName: '(بدون اسم)',
                fallbackName: 'جهة اتصال KAIXO',
                errNoPhone: 'لا يوجد هاتف — لا يمكن الحفظ',
                errMobileOnly: 'هذا الإجراء يعمل فقط في تطبيق الجوال',
                errPermDenied: 'تم رفض إذن جهات الاتصال',
                savedSuffix: 'تم حفظه في دفتر العناوين',
                errSavePrefix: 'تعذر الحفظ',
                viewProfile: 'عرض الملف'
            },
                correct: {"button": "تصحيح", "title": "تصحيح الإملاء والقواعد", "changed": "تم التصحيح", "clean": "لا توجد أخطاء", "error": "تعذر التصحيح"},
                photoTranslate: {"hint": "وجه إلى لافتة أو قائمة وصور", "processing": "يتم القراءة والترجمة...", "original": "النص المكتشف", "translation": "بلغتك", "listen": "استماع", "stop": "إيقاف", "copy": "نسخ", "sendToChat": "إرسال إلى المحادثة", "another": "صورة أخرى", "retry": "إعادة المحاولة", "close": "إغلاق", "errCamera": "تعذر الوصول إلى الكاميرا", "errProcess": "تعذر معالجة الصورة", "noText": "لم يتم اكتشاف نص في الصورة", "attachLabel": "مترجم الصور"}
        },
        profile: {
            title: 'تعديل الملف الشخصي', changePhoto: '📷 تغيير الصورة',
            name: 'الاسم', namePlaceholder: 'اسمك',
            status: 'الحالة', statusPlaceholder: 'مرحباً، أنا أستخدم Kaixo!',
            language: 'اللغة', languagePlaceholder: 'مثال: العربية، الإنجليزية...',
            region: 'المنطقة', regionPlaceholder: 'البلد أو المدينة',
            voice: 'صوت الرسائل', female: '👩 أنثى', male: '👨 ذكر',
            save: 'حفظ التغييرات', saving: 'جارٍ الحفظ...',
            error: { nameEmpty: 'لا يمكن أن يكون الاسم فارغاً', save: 'خطأ في الحفظ', connection: 'خطأ في الاتصال بالخادم' }
        },
        group: {
            participants: 'المشاركون', add: '➕ إضافة', leave: '🚪 مغادرة المجموعة',
            delete: '🗑️ حذف المجموعة', loading: 'جارٍ تحميل جهات الاتصال...',
            noContacts: 'جميع جهات اتصالك موجودة بالفعل في هذه المجموعة',
            selected: 'محدد', addBtn: 'إضافة',
            leaveConfirm: 'مغادرة المجموعة؟', leaveWarning: 'لن تتمكن من رؤية الرسائل.',
            deleteConfirm: 'هذا الإجراء لا يمكن التراجع عنه. ستُحذف المجموعة لجميع الأعضاء.',
            deleteConfirmText: 'هل أنت متأكد من الاستمرار؟',
            transferAdmin: 'نقل الإدارة', transferDesc: 'يجب تعيين مسؤول آخر قبل المغادرة.',
            transferAndLeave: 'نقل ومغادرة', creator: '👑 المنشئ', admin: '⭐ مسؤول',
            cancel: 'إلغاء', danger: 'مغادرة المجموعة', yesDelete: 'نعم، حذف المجموعة',
            error: { noContacts: 'اختر جهة اتصال واحدة على الأقل', add: 'خطأ في إضافة الأعضاء', remove: 'خطأ في إزالة العضو', leave: 'خطأ في مغادرة المجموعة', delete: 'خطأ في حذف المجموعة', removeCreator: 'لا يمكن إزالة منشئ المجموعة' }
        },
        createGroup: {
            title: 'إنشاء مجموعة جديدة', groupName: 'اسم المجموعة',
            groupNamePlaceholder: 'مثال: أصدقاء، عائلة، عمل...',
            selectMembers: 'اختر الأعضاء', noUsers: 'لا يوجد مستخدمون',
            cancel: 'إلغاء', creating: 'جارٍ الإنشاء...', create: 'إنشاء مجموعة',
            error: { noName: 'الرجاء إدخال اسم للمجموعة', noMembers: 'اختر جهة اتصال واحدة على الأقل', create: 'خطأ في إنشاء المجموعة' }
        },
        doc: {
            noPreview: 'هذا النوع من الملفات ليس له معاينة نصية.',
            downloadMsg: 'يمكنك تنزيله لعرضه.',
            sendTo: 'إرسال إلى...', send: 'إرسال', cancel: 'إلغاء'
        }
    },
    hi: {
        app: { subtitle: 'भाषा की बाधाओं के बिना संदेश' },
        login: {
            signin: 'साइन इन करें', signup: 'साइन अप करें',
            phone: 'फ़ोन', phonePlaceholder: '+91 98000 00000',
            password: 'पासवर्ड', passwordPlaceholder: '••••••••',
            passwordMin: 'कम से कम 6 अक्षर',
            repeatPassword: 'पासवर्ड दोहराएं', repeatPasswordPlaceholder: 'पासवर्ड दोहराएं',
            name: 'नाम', namePlaceholder: 'आपका नाम',
            language: 'भाषा', languagePlaceholder: 'जैसे: हिंदी, अंग्रेजी...',
            region: 'क्षेत्र', regionPlaceholder: 'देश या शहर',
            entering: 'प्रवेश हो रहा है...', enter: 'प्रवेश करें',
            creating: 'पंजीकरण हो रहा है...', createAccount: 'खाता बनाएं',
            error: {
                fillRequired: 'कृपया सभी आवश्यक फ़ील्ड भरें',
                passwordMismatch: 'पासवर्ड मेल नहीं खाते',
                passwordLength: 'पासवर्ड कम से कम 6 अक्षर का होना चाहिए',
                phonePassword: 'गलत फ़ोन या पासवर्ड',
                registerFailed: 'पंजीकरण विफल',
                connection: 'सर्वर से कनेक्ट करने में त्रुटि',
                phoneRequired: 'अपना फ़ोन और पासवर्ड दर्ज करें'
            }
        },
        conv: {
            loading: 'लोड हो रहा है...', createGroup: 'समूह बनाएं', logout: 'लॉग आउट',
            noLongerMember: 'अब सदस्य नहीं', noMessages: 'कोई संदेश नहीं',
            contacts: 'संपर्क', noUsers: 'कोई उपयोगकर्ता उपलब्ध नहीं'
        },
        chat: {
            loading: 'संदेश लोड हो रहे हैं...', selectConversation: 'चैट शुरू करने के लिए बातचीत चुनें',
            searchPlaceholder: 'बातचीत में खोजें...', members: 'सदस्य',
            online: 'ऑनलाइन', typingPlaceholder: 'में लिखें', send: 'भेजें',
            sendImage: 'छवि भेजें', sendVideo: 'वीडियो भेजें', sendAudio: 'ऑडियो भेजें',
            sendDocument: 'दस्तावेज़ भेजें', processing: 'वीडियो प्रोसेस हो रहा है...',
            translating: 'अनुवाद और भेजा जा रहा है...', sending: 'भेजा जा रहा है...',
            recording: 'रिकॉर्ड हो रहा है...', deleted: 'यह संदेश हटा दिया गया',
            addCaption: 'संदेश जोड़ें (वैकल्पिक)...',
            clearChatConfirm: 'चैट साफ़ करें? संदेश केवल आपके लिए हटाए जाएंगे।',
            deleteConvConfirm: 'यह बातचीत हटाएं? आप इसे पुनर्प्राप्त नहीं कर सकते।',
            leaveGroupConfirm: 'समूह छोड़ें?', leaveGroupWarning: 'आप संदेश नहीं देख पाएंगे।',
            leaveGroupAdmin: '⚠️ आप एकमात्र एडमिन हैं। छोड़ने से पहले स्थानांतरित करें।',
            leave: 'समूह छोड़ें', cancel: 'रद्द करें',
            forward: 'अग्रेषित करें', forwardMsg: 'संदेश अग्रेषित करें',
            deleteMsg: 'संदेश हटाएं', deleteForMe: 'मेरे लिए हटाएं', deleteForAll: 'सभी के लिए हटाएं',
            formerMember: 'आप इस समूह के सदस्य नहीं हैं',
            conversations: 'बातचीत', groups: 'समूह', loading2: 'लोड हो रहा है...',
            searchMenu: '🔍 खोजें', addMember: '➕ सदस्य जोड़ें', groupInfo: 'ℹ️ समूह जानकारी',
            contactInfo: 'ℹ️ संपर्क जानकारी', muteNotif: '🔕 सूचनाएं म्यूट करें',
            unmuteNotif: '🔔 सूचनाएं सक्रिय करें', addFav: '⭐ पसंदीदा में जोड़ें',
            removeFav: '★ पसंदीदा से हटाएं', block: '🚫 ब्लॉक करें', unblock: '✅ अनब्लॉक करें',
            clearChat: '🗑️ चैट साफ़ करें', deleteChat: '❌ बातचीत हटाएं', leaveGroupMenu: '🚪 समूह छोड़ें',
            pause: '⏸ रोकें', stop: '⏹ बंद करें', continue: '▶ जारी रखें',
            attach: '📎 संलग्न', gallery: '🖼️ गैलरी', document: '📄 दस्तावेज़',
            camera: '📷 कैमरा', recordVideo: '🎥 वीडियो रिकॉर्ड करें', audio: '🎙️ ऑडियो',
            voiceTranslation: 'रियल-टाइम वॉयस अनुवाद', listening: '🌐 सुन रहा है...',
            stopRecording: '⏹ बंद करें', errorSendMessage: 'संदेश भेजने में त्रुटि',
            errorSendVideo: 'वीडियो भेजने में त्रुटि', errorSendDocument: 'दस्तावेज़ भेजने में त्रुटि',
            errorCamera: 'कैमरा एक्सेस नहीं हो सका', errorMic: 'माइक्रोफ़ोन एक्सेस नहीं हो सका।',
            errorVoice: 'आपका ब्राउज़र वॉयस रिकग्निशन का समर्थन नहीं करता',
            capture: '📷 कैप्चर करें', record: '🔴 रिकॉर्ड करें', stopBtn: '⏹ बंद करें', cancelBtn: '✕ रद्द करें',
            contactCard: {
                type: 'KAIXO संपर्क',
                add: 'संपर्कों में जोड़ें',
                close: 'बंद करें',
                labelPhone: 'फ़ोन',
                labelEmail: 'ईमेल',
                labelLanguage: 'भाषा',
                labelPlace: 'स्थान',
                noName: '(कोई नाम नहीं)',
                fallbackName: 'KAIXO संपर्क',
                errNoPhone: 'फ़ोन नहीं है — सहेजा नहीं जा सकता',
                errMobileOnly: 'यह क्रिया केवल मोबाइल ऐप में काम करती है',
                errPermDenied: 'संपर्क अनुमति अस्वीकृत',
                savedSuffix: 'आपकी पता पुस्तिका में सहेजा गया',
                errSavePrefix: 'सहेजा नहीं जा सका',
                viewProfile: 'प्रोफ़ाइल देखें'
            },
                correct: {"button": "सुधारें", "title": "वर्तनी और व्याकरण सुधारें", "changed": "सुधारा गया", "clean": "कोई त्रुटि नहीं", "error": "सुधार नहीं हो सका"},
                photoTranslate: {"hint": "साइनबोर्ड या मेनू पर निशाना लगाएं", "processing": "पढ़ा और अनुवाद किया जा रहा है...", "original": "पहचाना गया पाठ", "translation": "आपकी भाषा में", "listen": "सुनें", "stop": "रोकें", "copy": "कॉपी करें", "sendToChat": "चैट पर भेजें", "another": "दूसरी फोटो", "retry": "पुनः प्रयास", "close": "बंद करें", "errCamera": "कैमरे तक पहुंच नहीं हो सका", "errProcess": "फोटो प्रोसेस नहीं हो सकी", "noText": "छवि में कोई पाठ नहीं मिला", "attachLabel": "फोटो अनुवादक"}
        },
        profile: {
            title: 'प्रोफ़ाइल संपादित करें', changePhoto: '📷 फ़ोटो बदलें',
            name: 'नाम', namePlaceholder: 'आपका नाम',
            status: 'स्थिति', statusPlaceholder: 'हे, मैं Kaixo इस्तेमाल कर रहा हूं!',
            language: 'भाषा', languagePlaceholder: 'जैसे: हिंदी, अंग्रेजी...',
            region: 'क्षेत्र', regionPlaceholder: 'देश या शहर',
            voice: 'संदेश की आवाज़', female: '👩 स्त्री', male: '👨 पुरुष',
            save: 'परिवर्तन सहेजें', saving: 'सहेजा जा रहा है...',
            error: { nameEmpty: 'नाम खाली नहीं हो सकता', save: 'सहेजने में त्रुटि', connection: 'सर्वर से कनेक्ट करने में त्रुटि' }
        },
        group: {
            participants: 'प्रतिभागी', add: '➕ जोड़ें', leave: '🚪 समूह छोड़ें',
            delete: '🗑️ समूह हटाएं', loading: 'संपर्क लोड हो रहे हैं...',
            noContacts: 'आपके सभी संपर्क पहले से इस समूह में हैं',
            selected: 'चुने गए', addBtn: 'जोड़ें',
            leaveConfirm: 'समूह छोड़ें?', leaveWarning: 'आप संदेश नहीं देख पाएंगे।',
            deleteConfirm: 'यह क्रिया वापस नहीं की जा सकती। समूह सभी सदस्यों के लिए हटाया जाएगा।',
            deleteConfirmText: 'क्या आप वाकई जारी रखना चाहते हैं?',
            transferAdmin: 'एडमिन स्थानांतरित करें', transferDesc: 'छोड़ने से पहले किसी अन्य एडमिन को नामित करें।',
            transferAndLeave: 'स्थानांतरित करें और छोड़ें', creator: '👑 निर्माता', admin: '⭐ एडमिन',
            cancel: 'रद्द करें', danger: 'समूह छोड़ें', yesDelete: 'हां, समूह हटाएं',
            error: { noContacts: 'कम से कम एक संपर्क चुनें', add: 'सदस्य जोड़ने में त्रुटि', remove: 'सदस्य हटाने में त्रुटि', leave: 'समूह छोड़ने में त्रुटि', delete: 'समूह हटाने में त्रुटि', removeCreator: 'आप समूह निर्माता को नहीं हटा सकते' }
        },
        createGroup: {
            title: 'नया समूह बनाएं', groupName: 'समूह का नाम',
            groupNamePlaceholder: 'जैसे: दोस्त, परिवार, काम...',
            selectMembers: 'सदस्य चुनें', noUsers: 'कोई उपयोगकर्ता उपलब्ध नहीं',
            cancel: 'रद्द करें', creating: 'बनाया जा रहा है...', create: 'समूह बनाएं',
            error: { noName: 'कृपया समूह का नाम दर्ज करें', noMembers: 'कम से कम एक संपर्क चुनें', create: 'समूह बनाने में त्रुटि' }
        },
        doc: {
            noPreview: 'इस फ़ाइल प्रकार का कोई टेक्स्ट पूर्वावलोकन नहीं है।',
            downloadMsg: 'आप इसे देखने के लिए डाउनलोड कर सकते हैं।',
            sendTo: 'भेजें...', send: 'भेजें', cancel: 'रद्द करें'
        }
    },
    ru: {
        app: { subtitle: 'Сообщения без языковых барьеров' },
        login: {
            signin: 'Войти', signup: 'Зарегистрироваться',
            phone: 'Телефон', phonePlaceholder: '+7 900 000 0000',
            password: 'Пароль', passwordPlaceholder: '••••••••',
            passwordMin: 'Минимум 6 символов',
            repeatPassword: 'Повторите пароль', repeatPasswordPlaceholder: 'Повторите пароль',
            name: 'Имя', namePlaceholder: 'Ваше имя',
            language: 'Язык', languagePlaceholder: 'например: русский, английский...',
            region: 'Регион', regionPlaceholder: 'Страна или город',
            entering: 'Вход...', enter: 'Войти',
            creating: 'Регистрация...', createAccount: 'Создать аккаунт',
            error: {
                fillRequired: 'Заполните все обязательные поля',
                passwordMismatch: 'Пароли не совпадают',
                passwordLength: 'Пароль должен содержать минимум 6 символов',
                phonePassword: 'Неверный телефон или пароль',
                registerFailed: 'Ошибка регистрации',
                connection: 'Ошибка подключения к серверу',
                phoneRequired: 'Введите телефон и пароль'
            }
        },
        conv: {
            loading: 'Загрузка...', createGroup: 'Создать группу', logout: 'Выйти',
            noLongerMember: 'Больше не участник', noMessages: 'Нет сообщений',
            contacts: 'Контакты', noUsers: 'Нет доступных пользователей'
        },
        chat: {
            loading: 'Загрузка сообщений...', selectConversation: 'Выберите разговор для начала чата',
            searchPlaceholder: 'Поиск в разговоре...', members: 'участников',
            online: 'В сети', typingPlaceholder: 'Пишите на', send: 'Отправить',
            sendImage: 'Отправить изображение', sendVideo: 'Отправить видео', sendAudio: 'Отправить аудио',
            sendDocument: 'Отправить документ', processing: 'Обработка видео...',
            translating: 'Перевод и отправка...', sending: 'Отправка...',
            recording: 'Запись...', deleted: 'Это сообщение было удалено',
            addCaption: 'Добавить сообщение (необязательно)...',
            clearChatConfirm: 'Очистить чат? Сообщения будут удалены только для вас.',
            deleteConvConfirm: 'Удалить этот разговор? Вы не сможете его восстановить.',
            leaveGroupConfirm: 'Покинуть группу?', leaveGroupWarning: 'Вы больше не сможете видеть сообщения.',
            leaveGroupAdmin: '⚠️ Вы единственный администратор. Передайте права перед выходом.',
            leave: 'Покинуть группу', cancel: 'Отмена',
            forward: 'Переслать', forwardMsg: 'Переслать сообщение',
            deleteMsg: 'Удалить сообщение', deleteForMe: 'Удалить для меня', deleteForAll: 'Удалить для всех',
            formerMember: 'Вы больше не являетесь участником этой группы',
            conversations: 'Разговоры', groups: 'Группы', loading2: 'Загрузка...',
            searchMenu: '🔍 Поиск', addMember: '➕ Добавить участника', groupInfo: 'ℹ️ Информация о группе',
            contactInfo: 'ℹ️ Информация о контакте', muteNotif: '🔕 Отключить уведомления',
            unmuteNotif: '🔔 Включить уведомления', addFav: '⭐ Добавить в избранное',
            removeFav: '★ Удалить из избранного', block: '🚫 Заблокировать', unblock: '✅ Разблокировать',
            clearChat: '🗑️ Очистить чат', deleteChat: '❌ Удалить разговор', leaveGroupMenu: '🚪 Покинуть группу',
            pause: '⏸ Пауза', stop: '⏹ Стоп', continue: '▶ Продолжить',
            attach: '📎 Прикрепить', gallery: '🖼️ Галерея', document: '📄 Документ',
            camera: '📷 Камера', recordVideo: '🎥 Записать видео', audio: '🎙️ Аудио',
            voiceTranslation: 'Перевод голоса в реальном времени', listening: '🌐 Слушаю...',
            stopRecording: '⏹ Стоп', errorSendMessage: 'Ошибка отправки сообщения',
            errorSendVideo: 'Ошибка отправки видео', errorSendDocument: 'Ошибка отправки документа',
            errorCamera: 'Нет доступа к камере', errorMic: 'Нет доступа к микрофону.',
            errorVoice: 'Ваш браузер не поддерживает распознавание речи',
            capture: '📷 Снять', record: '🔴 Записать', stopBtn: '⏹ Стоп', cancelBtn: '✕ Отмена',
            contactCard: {
                type: 'Контакт KAIXO',
                add: 'Добавить в контакты',
                close: 'Закрыть',
                labelPhone: 'Телефон',
                labelEmail: 'Эл. почта',
                labelLanguage: 'Язык',
                labelPlace: 'Местоположение',
                noName: '(без имени)',
                fallbackName: 'Контакт KAIXO',
                errNoPhone: 'Нет телефона — невозможно сохранить',
                errMobileOnly: 'Действие работает только в мобильном приложении',
                errPermDenied: 'Доступ к контактам запрещён',
                savedSuffix: 'сохранён в адресной книге',
                errSavePrefix: 'Не удалось сохранить',
                viewProfile: 'Открыть профиль'
            },
                correct: {"button": "Исправить", "title": "Исправить орфографию и грамматику", "changed": "Исправлено", "clean": "Ошибок нет", "error": "Не удалось исправить"},
                photoTranslate: {"hint": "Наведите на вывеску или меню и снимите", "processing": "Распознаём и переводим...", "original": "Распознанный текст", "translation": "На вашем языке", "listen": "Слушать", "stop": "Стоп", "copy": "Копировать", "sendToChat": "Отправить в чат", "another": "Другое фото", "retry": "Повторить", "close": "Закрыть", "errCamera": "Не удалось получить доступ к камере", "errProcess": "Не удалось обработать фото", "noText": "На изображении не найдено текста", "attachLabel": "Фотопереводчик"}
        },
        profile: {
            title: 'Редактировать профиль', changePhoto: '📷 Изменить фото',
            name: 'Имя', namePlaceholder: 'Ваше имя',
            status: 'Статус', statusPlaceholder: 'Привет, я использую Kaixo!',
            language: 'Язык', languagePlaceholder: 'например: русский, английский...',
            region: 'Регион', regionPlaceholder: 'Страна или город',
            voice: 'Голос для сообщений', female: '👩 Женский', male: '👨 Мужской',
            save: 'Сохранить изменения', saving: 'Сохранение...',
            error: { nameEmpty: 'Имя не может быть пустым', save: 'Ошибка сохранения', connection: 'Ошибка подключения к серверу' }
        },
        group: {
            participants: 'Участники', add: '➕ Добавить', leave: '🚪 Покинуть Группу',
            delete: '🗑️ Удалить Группу', loading: 'Загрузка контактов...',
            noContacts: 'Все ваши контакты уже в этой группе',
            selected: 'выбрано', addBtn: 'Добавить',
            leaveConfirm: 'Покинуть группу?', leaveWarning: 'Вы больше не сможете видеть сообщения.',
            deleteConfirm: 'Это действие НЕВОЗМОЖНО отменить. Группа будет удалена для ВСЕХ участников.',
            deleteConfirmText: 'Вы уверены, что хотите продолжить?',
            transferAdmin: 'Передать Администрирование', transferDesc: 'Вы должны назначить другого администратора перед выходом.',
            transferAndLeave: 'Передать и Выйти', creator: '👑 Создатель', admin: '⭐ Администратор',
            cancel: 'Отмена', danger: 'Покинуть Группу', yesDelete: 'Да, Удалить Группу',
            error: { noContacts: 'Выберите хотя бы один контакт', add: 'Ошибка добавления участников', remove: 'Ошибка удаления участника', leave: 'Ошибка выхода из группы', delete: 'Ошибка удаления группы', removeCreator: 'Невозможно удалить создателя группы' }
        },
        createGroup: {
            title: 'Создать Новую Группу', groupName: 'Название группы',
            groupNamePlaceholder: 'Например: Друзья, Семья, Работа...',
            selectMembers: 'Выбрать участников', noUsers: 'Нет доступных пользователей',
            cancel: 'Отмена', creating: 'Создание...', create: 'Создать Группу',
            error: { noName: 'Пожалуйста, введите название группы', noMembers: 'Выберите хотя бы один контакт', create: 'Ошибка создания группы' }
        },
        doc: {
            noPreview: 'Этот тип файла не имеет текстового предпросмотра.',
            downloadMsg: 'Вы можете скачать его для просмотра.',
            sendTo: 'Отправить...', send: 'Отправить', cancel: 'Отмена'
        }
    },
    ko: {
        app: { subtitle: '언어 장벽 없는 메시지' },
        login: {
            signin: '로그인', signup: '회원가입',
            phone: '전화번호', phonePlaceholder: '+82 10 0000 0000',
            password: '비밀번호', passwordPlaceholder: '••••••••',
            passwordMin: '최소 6자',
            repeatPassword: '비밀번호 확인', repeatPasswordPlaceholder: '비밀번호를 반복하세요',
            name: '이름', namePlaceholder: '당신의 이름',
            language: '언어', languagePlaceholder: '예: 한국어, 영어...',
            region: '지역', regionPlaceholder: '국가 또는 도시',
            entering: '로그인 중...', enter: '로그인',
            creating: '등록 중...', createAccount: '계정 만들기',
            error: {
                fillRequired: '모든 필수 항목을 입력하세요',
                passwordMismatch: '비밀번호가 일치하지 않습니다',
                passwordLength: '비밀번호는 최소 6자 이상이어야 합니다',
                phonePassword: '전화번호 또는 비밀번호가 올바르지 않습니다',
                registerFailed: '등록 실패',
                connection: '서버 연결 오류',
                phoneRequired: '전화번호와 비밀번호를 입력하세요'
            }
        },
        conv: {
            loading: '로딩 중...', createGroup: '그룹 만들기', logout: '로그아웃',
            noLongerMember: '더 이상 멤버가 아닙니다', noMessages: '메시지 없음',
            contacts: '연락처', noUsers: '사용 가능한 사용자 없음'
        },
        chat: {
            loading: '메시지 로딩 중...', selectConversation: '채팅을 시작할 대화를 선택하세요',
            searchPlaceholder: '대화에서 검색...', members: '멤버',
            online: '온라인', typingPlaceholder: '입력 언어', send: '보내기',
            sendImage: '이미지 보내기', sendVideo: '비디오 보내기', sendAudio: '오디오 보내기',
            sendDocument: '문서 보내기', processing: '비디오 처리 중...',
            translating: '번역 및 전송 중...', sending: '전송 중...',
            recording: '녹음 중...', deleted: '이 메시지가 삭제되었습니다',
            addCaption: '메시지 추가 (선택사항)...',
            clearChatConfirm: '채팅 지우기? 메시지는 나에게만 삭제됩니다.',
            deleteConvConfirm: '이 대화를 삭제하시겠습니까? 복구할 수 없습니다.',
            leaveGroupConfirm: '그룹을 떠나시겠습니까?', leaveGroupWarning: '더 이상 메시지를 볼 수 없습니다.',
            leaveGroupAdmin: '⚠️ 유일한 관리자입니다. 떠나기 전에 이전하세요.',
            leave: '그룹 떠나기', cancel: '취소',
            forward: '전달', forwardMsg: '메시지 전달',
            deleteMsg: '메시지 삭제', deleteForMe: '나만 삭제', deleteForAll: '모두 삭제',
            formerMember: '이 그룹의 멤버가 아닙니다',
            conversations: '대화', groups: '그룹', loading2: '로딩 중...',
            searchMenu: '🔍 검색', addMember: '➕ 멤버 추가', groupInfo: 'ℹ️ 그룹 정보',
            contactInfo: 'ℹ️ 연락처 정보', muteNotif: '🔕 알림 음소거',
            unmuteNotif: '🔔 알림 활성화', addFav: '⭐ 즐겨찾기에 추가',
            removeFav: '★ 즐겨찾기에서 제거', block: '🚫 차단', unblock: '✅ 차단 해제',
            clearChat: '🗑️ 채팅 지우기', deleteChat: '❌ 대화 삭제', leaveGroupMenu: '🚪 그룹 떠나기',
            pause: '⏸ 일시정지', stop: '⏹ 정지', continue: '▶ 계속',
            attach: '📎 첨부', gallery: '🖼️ 갤러리', document: '📄 문서',
            camera: '📷 카메라', recordVideo: '🎥 비디오 녹화', audio: '🎙️ 오디오',
            voiceTranslation: '실시간 음성 번역', listening: '🌐 듣는 중...',
            stopRecording: '⏹ 정지', errorSendMessage: '메시지 전송 오류',
            errorSendVideo: '비디오 전송 오류', errorSendDocument: '문서 전송 오류',
            errorCamera: '카메라에 액세스할 수 없습니다', errorMic: '마이크에 액세스할 수 없습니다.',
            errorVoice: '브라우저가 음성 인식을 지원하지 않습니다',
            capture: '📷 캡처', record: '🔴 녹화', stopBtn: '⏹ 정지', cancelBtn: '✕ 취소',
            contactCard: {
                type: 'KAIXO 연락처',
                add: '연락처에 추가',
                close: '닫기',
                labelPhone: '전화',
                labelEmail: '이메일',
                labelLanguage: '언어',
                labelPlace: '위치',
                noName: '(이름 없음)',
                fallbackName: 'KAIXO 연락처',
                errNoPhone: '전화번호가 없어 저장할 수 없습니다',
                errMobileOnly: '이 작업은 모바일 앱에서만 작동합니다',
                errPermDenied: '연락처 권한이 거부되었습니다',
                savedSuffix: '주소록에 저장됨',
                errSavePrefix: '저장할 수 없습니다',
                viewProfile: '프로필 보기'
            },
                correct: {"button": "교정", "title": "맞춤법 및 문법 교정", "changed": "교정됨", "clean": "오류 없음", "error": "교정할 수 없음"},
                photoTranslate: {"hint": "표지판이나 메뉴를 향해 촬영", "processing": "읽고 번역 중...", "original": "감지된 텍스트", "translation": "내 언어로", "listen": "듣기", "stop": "정지", "copy": "복사", "sendToChat": "채팅으로 보내기", "another": "다른 사진", "retry": "다시 시도", "close": "닫기", "errCamera": "카메라에 접근할 수 없습니다", "errProcess": "사진을 처리할 수 없습니다", "noText": "이미지에서 텍스트를 찾을 수 없습니다", "attachLabel": "사진 번역기"}
        },
        profile: {
            title: '프로필 편집', changePhoto: '📷 사진 변경',
            name: '이름', namePlaceholder: '당신의 이름',
            status: '상태', statusPlaceholder: '안녕하세요, Kaixo를 사용하고 있습니다!',
            language: '언어', languagePlaceholder: '예: 한국어, 영어...',
            region: '지역', regionPlaceholder: '국가 또는 도시',
            voice: '메시지 음성', female: '👩 여성', male: '👨 남성',
            save: '변경사항 저장', saving: '저장 중...',
            error: { nameEmpty: '이름은 비어 있을 수 없습니다', save: '저장 오류', connection: '서버 연결 오류' }
        },
        group: {
            participants: '참가자', add: '➕ 추가', leave: '🚪 그룹 떠나기',
            delete: '🗑️ 그룹 삭제', loading: '연락처 로딩 중...',
            noContacts: '모든 연락처가 이미 이 그룹에 있습니다',
            selected: '선택됨', addBtn: '추가',
            leaveConfirm: '그룹을 떠나시겠습니까?', leaveWarning: '더 이상 메시지를 볼 수 없습니다.',
            deleteConfirm: '이 작업은 취소할 수 없습니다. 모든 멤버의 그룹이 삭제됩니다.',
            deleteConfirmText: '계속하시겠습니까?',
            transferAdmin: '관리자 이전', transferDesc: '떠나기 전에 다른 관리자를 지정해야 합니다.',
            transferAndLeave: '이전하고 떠나기', creator: '👑 생성자', admin: '⭐ 관리자',
            cancel: '취소', danger: '그룹 떠나기', yesDelete: '예, 그룹 삭제',
            error: { noContacts: '최소 하나의 연락처를 선택하세요', add: '멤버 추가 오류', remove: '멤버 제거 오류', leave: '그룹 떠나기 오류', delete: '그룹 삭제 오류', removeCreator: '그룹 생성자를 제거할 수 없습니다' }
        },
        createGroup: {
            title: '새 그룹 만들기', groupName: '그룹 이름',
            groupNamePlaceholder: '예: 친구, 가족, 일...',
            selectMembers: '멤버 선택', noUsers: '사용 가능한 사용자 없음',
            cancel: '취소', creating: '생성 중...', create: '그룹 만들기',
            error: { noName: '그룹 이름을 입력하세요', noMembers: '최소 하나의 연락처를 선택하세요', create: '그룹 생성 오류' }
        },
        doc: {
            noPreview: '이 파일 형식은 텍스트 미리보기가 없습니다.',
            downloadMsg: '다운로드하여 볼 수 있습니다.',
            sendTo: '보내기...', send: '보내기', cancel: '취소'
        }
    },
    tr: {
        app: { subtitle: 'Dil engeli olmaksızın mesajlaşma' },
        login: {
            signin: 'Giriş yap', signup: 'Kayıt ol',
            phone: 'Telefon', phonePlaceholder: '+90 500 000 0000',
            password: 'Şifre', passwordPlaceholder: '••••••••',
            passwordMin: 'En az 6 karakter',
            repeatPassword: 'Şifreyi tekrarla', repeatPasswordPlaceholder: 'Şifrenizi tekrarlayın',
            name: 'İsim', namePlaceholder: 'Adınız',
            language: 'Dil', languagePlaceholder: 'örn: Türkçe, İngilizce...',
            region: 'Bölge', regionPlaceholder: 'Ülke veya şehir',
            entering: 'Giriş yapılıyor...', enter: 'Giriş yap',
            creating: 'Kaydediliyor...', createAccount: 'Hesap oluştur',
            error: {
                fillRequired: 'Lütfen tüm zorunlu alanları doldurun',
                passwordMismatch: 'Şifreler eşleşmiyor',
                passwordLength: 'Şifre en az 6 karakter olmalıdır',
                phonePassword: 'Yanlış telefon veya şifre',
                registerFailed: 'Kayıt başarısız',
                connection: 'Sunucuya bağlanma hatası',
                phoneRequired: 'Telefonunuzu ve şifrenizi girin'
            }
        },
        conv: {
            loading: 'Yükleniyor...', createGroup: 'Grup oluştur', logout: 'Çıkış yap',
            noLongerMember: 'Artık üye değilsiniz', noMessages: 'Mesaj yok',
            contacts: 'Kişiler', noUsers: 'Kullanılabilir kullanıcı yok'
        },
        chat: {
            loading: 'Mesajlar yükleniyor...', selectConversation: 'Sohbet başlatmak için bir konuşma seçin',
            searchPlaceholder: 'Konuşmada ara...', members: 'üye',
            online: 'Çevrimiçi', typingPlaceholder: 'şu dilde yaz', send: 'Gönder',
            sendImage: 'Resim gönder', sendVideo: 'Video gönder', sendAudio: 'Ses gönder',
            sendDocument: 'Belge gönder', processing: 'Video işleniyor...',
            translating: 'Çeviriliyor ve gönderiliyor...', sending: 'Gönderiliyor...',
            recording: 'Kaydediliyor...', deleted: 'Bu mesaj silindi',
            addCaption: 'Mesaj ekle (isteğe bağlı)...',
            clearChatConfirm: 'Sohbeti temizle? Mesajlar yalnızca sizin için silinecek.',
            deleteConvConfirm: 'Bu konuşmayı sil? Kurtaramazsınız.',
            leaveGroupConfirm: 'Gruptan ayrıl?', leaveGroupWarning: 'Artık mesajları göremeyeceksiniz.',
            leaveGroupAdmin: '⚠️ Tek yöneticisiniz. Ayrılmadan önce aktarın.',
            leave: 'Gruptan ayrıl', cancel: 'İptal',
            forward: 'İlet', forwardMsg: 'Mesajı ilet',
            deleteMsg: 'Mesajı sil', deleteForMe: 'Benim için sil', deleteForAll: 'Herkes için sil',
            formerMember: 'Bu grubun üyesi değilsiniz',
            conversations: 'Konuşmalar', groups: 'Gruplar', loading2: 'Yükleniyor...',
            searchMenu: '🔍 Ara', addMember: '➕ Üye ekle', groupInfo: 'ℹ️ Grup bilgisi',
            contactInfo: 'ℹ️ Kişi bilgisi', muteNotif: '🔕 Bildirimleri sessize al',
            unmuteNotif: '🔔 Bildirimleri etkinleştir', addFav: '⭐ Favorilere ekle',
            removeFav: '★ Favorilerden kaldır', block: '🚫 Engelle', unblock: '✅ Engeli kaldır',
            clearChat: '🗑️ Sohbeti temizle', deleteChat: '❌ Konuşmayı sil', leaveGroupMenu: '🚪 Gruptan ayrıl',
            pause: '⏸ Duraklat', stop: '⏹ Durdur', continue: '▶ Devam',
            attach: '📎 Ekle', gallery: '🖼️ Galeri', document: '📄 Belge',
            camera: '📷 Kamera', recordVideo: '🎥 Video kaydet', audio: '🎙️ Ses',
            voiceTranslation: 'Gerçek zamanlı ses çevirisi', listening: '🌐 Dinleniyor...',
            stopRecording: '⏹ Durdur', errorSendMessage: 'Mesaj gönderme hatası',
            errorSendVideo: 'Video gönderme hatası', errorSendDocument: 'Belge gönderme hatası',
            errorCamera: 'Kameraya erişilemiyor', errorMic: 'Mikrofona erişilemiyor.',
            errorVoice: 'Tarayıcınız ses tanımayı desteklemiyor',
            capture: '📷 Çek', record: '🔴 Kaydet', stopBtn: '⏹ Durdur', cancelBtn: '✕ İptal',
            contactCard: {
                type: 'KAIXO kişisi',
                add: 'Kişilere ekle',
                close: 'Kapat',
                labelPhone: 'Telefon',
                labelEmail: 'E-posta',
                labelLanguage: 'Dil',
                labelPlace: 'Konum',
                noName: '(isim yok)',
                fallbackName: 'KAIXO kişisi',
                errNoPhone: 'Telefon yok — kaydedilemiyor',
                errMobileOnly: 'Bu işlem yalnızca mobil uygulamada çalışır',
                errPermDenied: 'Kişi izni reddedildi',
                savedSuffix: 'rehberinize kaydedildi',
                errSavePrefix: 'Kaydedilemedi',
                viewProfile: 'Profili görüntüle'
            },
                correct: {"button": "Duzelt", "title": "Yazim ve dilbilgisini duzelt", "changed": "Duzeltildi", "clean": "Hata yok", "error": "Duzeltilemedi"},
                photoTranslate: {"hint": "Bir tabela veya menuye dogrult ve cek", "processing": "Okunuyor ve cevriliyor...", "original": "Algilanan metin", "translation": "Senin dilinde", "listen": "Dinle", "stop": "Durdur", "copy": "Kopyala", "sendToChat": "Sohbete gonder", "another": "Baska fotograf", "retry": "Yeniden dene", "close": "Kapat", "errCamera": "Kameraya erisilemedi", "errProcess": "Fotograf islenemedi", "noText": "Goruntude metin algilanamadi", "attachLabel": "Foto Çevirmen"}
        },
        profile: {
            title: 'Profili düzenle', changePhoto: '📷 Fotoğrafı değiştir',
            name: 'İsim', namePlaceholder: 'Adınız',
            status: 'Durum', statusPlaceholder: 'Merhaba, Kaixo kullanıyorum!',
            language: 'Dil', languagePlaceholder: 'örn: Türkçe, İngilizce...',
            region: 'Bölge', regionPlaceholder: 'Ülke veya şehir',
            voice: 'Mesaj sesi', female: '👩 Kadın', male: '👨 Erkek',
            save: 'Değişiklikleri kaydet', saving: 'Kaydediliyor...',
            error: { nameEmpty: 'İsim boş olamaz', save: 'Kaydetme hatası', connection: 'Sunucuya bağlanma hatası' }
        },
        group: {
            participants: 'Katılımcılar', add: '➕ Ekle', leave: '🚪 Gruptan Ayrıl',
            delete: '🗑️ Grubu Sil', loading: 'Kişiler yükleniyor...',
            noContacts: 'Tüm kişileriniz zaten bu grupta',
            selected: 'seçildi', addBtn: 'Ekle',
            leaveConfirm: 'Gruptan ayrıl?', leaveWarning: 'Artık mesajları göremeyeceksiniz.',
            deleteConfirm: 'Bu işlem GERİ ALINAMAZ. Grup TÜM üyeler için silinecek.',
            deleteConfirmText: 'Devam etmek istediğinizden emin misiniz?',
            transferAdmin: 'Yönetimi Aktar', transferDesc: 'Ayrılmadan önce başka bir yönetici atamalısınız.',
            transferAndLeave: 'Aktar ve Ayrıl', creator: '👑 Oluşturan', admin: '⭐ Yönetici',
            cancel: 'İptal', danger: 'Gruptan Ayrıl', yesDelete: 'Evet, Grubu Sil',
            error: { noContacts: 'En az bir kişi seçin', add: 'Üye ekleme hatası', remove: 'Üye kaldırma hatası', leave: 'Gruptan ayrılma hatası', delete: 'Grup silme hatası', removeCreator: 'Grup oluşturucuyu kaldıramazsınız' }
        },
        createGroup: {
            title: 'Yeni Grup Oluştur', groupName: 'Grup adı',
            groupNamePlaceholder: 'Örn: Arkadaşlar, Aile, İş...',
            selectMembers: 'Üye seç', noUsers: 'Kullanılabilir kullanıcı yok',
            cancel: 'İptal', creating: 'Oluşturuluyor...', create: 'Grup Oluştur',
            error: { noName: 'Lütfen grup adı girin', noMembers: 'En az bir kişi seçin', create: 'Grup oluşturma hatası' }
        },
        doc: {
            noPreview: 'Bu dosya türünün metin önizlemesi yok.',
            downloadMsg: 'Görüntülemek için indirebilirsiniz.',
            sendTo: 'Gönder...', send: 'Gönder', cancel: 'İptal'
        }
    },
    id: {
        app: { subtitle: 'Pesan tanpa hambatan bahasa' },
        login: {
            signin: 'Masuk', signup: 'Daftar',
            phone: 'Telepon', phonePlaceholder: '+62 812 0000 0000',
            password: 'Kata sandi', passwordPlaceholder: '••••••••',
            passwordMin: 'Minimal 6 karakter',
            repeatPassword: 'Ulangi kata sandi', repeatPasswordPlaceholder: 'Ulangi kata sandi',
            name: 'Nama', namePlaceholder: 'Nama Anda',
            language: 'Bahasa', languagePlaceholder: 'mis: Indonesia, Inggris...',
            region: 'Wilayah', regionPlaceholder: 'Negara atau kota',
            entering: 'Masuk...', enter: 'Masuk',
            creating: 'Mendaftar...', createAccount: 'Buat akun',
            error: {
                fillRequired: 'Harap isi semua kolom wajib',
                passwordMismatch: 'Kata sandi tidak cocok',
                passwordLength: 'Kata sandi minimal 6 karakter',
                phonePassword: 'Telepon atau kata sandi salah',
                registerFailed: 'Pendaftaran gagal',
                connection: 'Kesalahan koneksi ke server',
                phoneRequired: 'Masukkan telepon dan kata sandi Anda'
            }
        },
        conv: {
            loading: 'Memuat...', createGroup: 'Buat grup', logout: 'Keluar',
            noLongerMember: 'Bukan anggota lagi', noMessages: 'Tidak ada pesan',
            contacts: 'Kontak', noUsers: 'Tidak ada pengguna tersedia'
        },
        chat: {
            loading: 'Memuat pesan...', selectConversation: 'Pilih percakapan untuk mulai mengobrol',
            searchPlaceholder: 'Cari di percakapan...', members: 'anggota',
            online: 'Online', typingPlaceholder: 'Ketik dalam', send: 'Kirim',
            sendImage: 'Kirim gambar', sendVideo: 'Kirim video', sendAudio: 'Kirim audio',
            sendDocument: 'Kirim dokumen', processing: 'Memproses video...',
            translating: 'Menerjemahkan dan mengirim...', sending: 'Mengirim...',
            recording: 'Merekam...', deleted: 'Pesan ini telah dihapus',
            addCaption: 'Tambahkan pesan (opsional)...',
            clearChatConfirm: 'Hapus obrolan? Pesan hanya akan dihapus untuk Anda.',
            deleteConvConfirm: 'Hapus percakapan ini? Tidak dapat dipulihkan.',
            leaveGroupConfirm: 'Keluar dari grup?', leaveGroupWarning: 'Anda tidak akan dapat melihat pesan lagi.',
            leaveGroupAdmin: '⚠️ Anda adalah satu-satunya admin. Transfer sebelum keluar.',
            leave: 'Keluar dari grup', cancel: 'Batal',
            forward: 'Teruskan', forwardMsg: 'Teruskan pesan',
            deleteMsg: 'Hapus pesan', deleteForMe: 'Hapus untuk saya', deleteForAll: 'Hapus untuk semua',
            formerMember: 'Anda bukan anggota grup ini',
            conversations: 'Percakapan', groups: 'Grup', loading2: 'Memuat...',
            searchMenu: '🔍 Cari', addMember: '➕ Tambah anggota', groupInfo: 'ℹ️ Info grup',
            contactInfo: 'ℹ️ Info kontak', muteNotif: '🔕 Senyapkan notifikasi',
            unmuteNotif: '🔔 Aktifkan notifikasi', addFav: '⭐ Tambahkan ke favorit',
            removeFav: '★ Hapus dari favorit', block: '🚫 Blokir', unblock: '✅ Buka blokir',
            clearChat: '🗑️ Hapus obrolan', deleteChat: '❌ Hapus percakapan', leaveGroupMenu: '🚪 Keluar dari grup',
            pause: '⏸ Jeda', stop: '⏹ Berhenti', continue: '▶ Lanjutkan',
            attach: '📎 Lampirkan', gallery: '🖼️ Galeri', document: '📄 Dokumen',
            camera: '📷 Kamera', recordVideo: '🎥 Rekam video', audio: '🎙️ Audio',
            voiceTranslation: 'Terjemahan suara real-time', listening: '🌐 Mendengarkan...',
            stopRecording: '⏹ Berhenti', errorSendMessage: 'Kesalahan mengirim pesan',
            errorSendVideo: 'Kesalahan mengirim video', errorSendDocument: 'Kesalahan mengirim dokumen',
            errorCamera: 'Tidak dapat mengakses kamera', errorMic: 'Tidak dapat mengakses mikrofon.',
            errorVoice: 'Browser Anda tidak mendukung pengenalan suara',
            capture: '📷 Ambil', record: '🔴 Rekam', stopBtn: '⏹ Berhenti', cancelBtn: '✕ Batal',
            contactCard: {
                type: 'Kontak KAIXO',
                add: 'Tambah ke kontak',
                close: 'Tutup',
                labelPhone: 'Telepon',
                labelEmail: 'Email',
                labelLanguage: 'Bahasa',
                labelPlace: 'Lokasi',
                noName: '(tanpa nama)',
                fallbackName: 'Kontak KAIXO',
                errNoPhone: 'Tidak ada telepon — tidak bisa disimpan',
                errMobileOnly: 'Tindakan ini hanya berfungsi di aplikasi seluler',
                errPermDenied: 'Izin kontak ditolak',
                savedSuffix: 'disimpan di buku alamat Anda',
                errSavePrefix: 'Tidak bisa menyimpan',
                viewProfile: 'Lihat profil'
            },
                correct: {"button": "Koreksi", "title": "Koreksi ejaan dan tata bahasa", "changed": "Dikoreksi", "clean": "Tidak ada kesalahan", "error": "Tidak bisa mengoreksi"},
                photoTranslate: {"hint": "Arahkan ke papan atau menu lalu jepret", "processing": "Membaca dan menerjemahkan...", "original": "Teks terdeteksi", "translation": "Dalam bahasa Anda", "listen": "Dengarkan", "stop": "Berhenti", "copy": "Salin", "sendToChat": "Kirim ke chat", "another": "Foto lain", "retry": "Coba lagi", "close": "Tutup", "errCamera": "Tidak dapat mengakses kamera", "errProcess": "Tidak dapat memproses foto", "noText": "Tidak ada teks terdeteksi pada gambar", "attachLabel": "Penerjemah Foto"}
        },
        profile: {
            title: 'Edit profil', changePhoto: '📷 Ganti foto',
            name: 'Nama', namePlaceholder: 'Nama Anda',
            status: 'Status', statusPlaceholder: 'Hei, saya menggunakan Kaixo!',
            language: 'Bahasa', languagePlaceholder: 'mis: Indonesia, Inggris...',
            region: 'Wilayah', regionPlaceholder: 'Negara atau kota',
            voice: 'Suara pesan', female: '👩 Perempuan', male: '👨 Laki-laki',
            save: 'Simpan perubahan', saving: 'Menyimpan...',
            error: { nameEmpty: 'Nama tidak boleh kosong', save: 'Kesalahan menyimpan', connection: 'Kesalahan koneksi ke server' }
        },
        group: {
            participants: 'Peserta', add: '➕ Tambah', leave: '🚪 Keluar dari Grup',
            delete: '🗑️ Hapus Grup', loading: 'Memuat kontak...',
            noContacts: 'Semua kontak Anda sudah ada di grup ini',
            selected: 'dipilih', addBtn: 'Tambah',
            leaveConfirm: 'Keluar dari grup?', leaveWarning: 'Anda tidak akan dapat melihat pesan.',
            deleteConfirm: 'Tindakan ini TIDAK DAPAT dibatalkan. Grup akan dihapus untuk SEMUA anggota.',
            deleteConfirmText: 'Apakah Anda yakin ingin melanjutkan?',
            transferAdmin: 'Transfer Administrasi', transferDesc: 'Anda harus menunjuk admin lain sebelum keluar.',
            transferAndLeave: 'Transfer dan Keluar', creator: '👑 Pembuat', admin: '⭐ Admin',
            cancel: 'Batal', danger: 'Keluar dari Grup', yesDelete: 'Ya, Hapus Grup',
            error: { noContacts: 'Pilih setidaknya satu kontak', add: 'Kesalahan menambahkan anggota', remove: 'Kesalahan menghapus anggota', leave: 'Kesalahan keluar dari grup', delete: 'Kesalahan menghapus grup', removeCreator: 'Anda tidak dapat menghapus pembuat grup' }
        },
        createGroup: {
            title: 'Buat Grup Baru', groupName: 'Nama grup',
            groupNamePlaceholder: 'Mis: Teman, Keluarga, Kerja...',
            selectMembers: 'Pilih anggota', noUsers: 'Tidak ada pengguna tersedia',
            cancel: 'Batal', creating: 'Membuat...', create: 'Buat Grup',
            error: { noName: 'Harap masukkan nama grup', noMembers: 'Pilih setidaknya satu kontak', create: 'Kesalahan membuat grup' }
        },
        doc: {
            noPreview: 'Jenis file ini tidak memiliki pratinjau teks.',
            downloadMsg: 'Anda dapat mengunduhnya untuk melihatnya.',
            sendTo: 'Kirim ke...', send: 'Kirim', cancel: 'Batal'
        }
    }
};

function getLanguageCode() {
    const lang = navigator.language || navigator.userLanguage || 'es';
    const code = lang.split('-')[0].toLowerCase();
    return translations[code] ? code : 'en';
}

export function getTranslations() {
    const code = getLanguageCode();
    return translations[code] || translations['en'];
}

export default translations;